(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._tooltip_5svgn_1{width:260px}._popover_5svgn_5{background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);box-sizing:border-box;z-index:100}._bar_1n5dj_1{overflow:hidden}._section_1n5dj_5{position:relative}._sectionHidden_1n5dj_8{display:none!important}._sectionInheritRadius_1n5dj_11{border-radius:inherit}._valueOutside_1n5dj_15{left:calc(100% + var(--dixa-size-spacer-100));z-index:1;position:absolute}:root{--dixa-analytics-color-default-1:var(--dixa-color-purple-700);--dixa-analytics-color-default-2:var(--dixa-color-blue-300);--dixa-analytics-color-default-3:var(--dixa-color-red-500);--dixa-analytics-color-default-4:var(--dixa-color-orange-300);--dixa-analytics-color-default-5:var(--dixa-color-purple-500);--dixa-analytics-color-default-6:var(--dixa-color-green-400);--dixa-analytics-color-default-7:var(--dixa-color-neutral-600);--dixa-analytics-color-default-8:var(--dixa-color-neutral-400);--dixa-analytics-color-rating-1:var(--dixa-color-red-600);--dixa-analytics-color-rating-2:var(--dixa-color-red-400);--dixa-analytics-color-rating-3:var(--dixa-color-orange-300);--dixa-analytics-color-rating-4:var(--dixa-color-green-500);--dixa-analytics-color-rating-5:var(--dixa-color-green-600)}[data-color-mode=dark]{--dixa-analytics-color-default-1:var(--dixa-color-blue-300);--dixa-analytics-color-default-2:var(--dixa-color-blue-700);--dixa-analytics-color-default-3:var(--dixa-color-red-400);--dixa-analytics-color-default-4:var(--dixa-color-orange-600);--dixa-analytics-color-default-5:var(--dixa-color-purple-500);--dixa-analytics-color-default-6:var(--dixa-color-green-500);--dixa-analytics-color-default-7:var(--dixa-color-neutral-400);--dixa-analytics-color-default-8:var(--dixa-color-neutral-800);--dixa-analytics-color-rating-1:var(--dixa-color-red-400);--dixa-analytics-color-rating-2:var(--dixa-color-red-600);--dixa-analytics-color-rating-3:var(--dixa-color-orange-600);--dixa-analytics-color-rating-4:var(--dixa-color-green-400);--dixa-analytics-color-rating-5:var(--dixa-color-green-300)}._container_1t2a7_1{overflow:hidden}._root_6kwn9_1{column-gap:var(--dixa-size-spacer-200);row-gap:var(--dixa-size-spacer-300);white-space:nowrap;display:grid}._root_6kwn9_1:not(._rootBounded_6kwn9_7):not(._rootFluid_6kwn9_7){grid-template-columns:repeat(auto-fit, minmax(min(100% / 2 - var(--dixa-size-spacer-200) * (2 - 1) / 2, max(96px, 100% / 6 - var(--dixa-size-spacer-200) * (6 - 1) / 6)), 1fr))}._rootFluid_6kwn9_7,._rootBounded_6kwn9_7{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_6kwn9_7{max-width:calc(6 * 96px + var(--dixa-size-spacer-200) * (6 - 1))}._wrapper_1w7q6_1{align-self:flex-start;display:inline-flex}._text_1w7q6_6{font-size:var(--dixa-typography-size-600)}._colorIndicator_luubh_1{border-radius:50%;flex-shrink:0;width:6px;height:6px}._root_scczo_54{gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);box-shadow:var(--dixa-effect-box-shadow-300);background-color:var(--lightningcss-light,var(--dixa-color-neutral-900))var(--lightningcss-dark,var(--dixa-color-neutral-200));flex-direction:column;display:flex}@supports not (color:light-dark(white, black)){._root_scczo_54{background-color:var(--dixa-color-neutral-900)}}._root_scczo_54{color:var(--lightningcss-light,var(--dixa-color-neutral-000))var(--lightningcss-dark,var(--dixa-typography-color-primary))}@supports not (color:light-dark(white, black)){._root_scczo_54{color:var(--dixa-color-neutral-000)}}._legendItem_15b15_54{white-space:nowrap;cursor:pointer;opacity:1;flex-shrink:0;overflow:hidden}._legendItemInactive_15b15_61{opacity:.4}._legendIcon_15b15_65{border-radius:var(--dixa-size-border-radius-50);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-sizing:border-box;flex-shrink:0;width:12px}._legendIconBar_15b15_72{height:12px}._legendIconLine_15b15_75{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_hfkay_1{cursor:default;opacity:1;flex-direction:column;justify-content:center;align-items:center;height:100%;transition:opacity .2s ease-in-out;display:flex}._cell_hfkay_1:hover ._cellText_hfkay_11{color:var(--dixa-typography-color-primary)}._cellDimmed_hfkay_14{opacity:var(--dixa-effect-opacity-200)}._cellContent_hfkay_18{justify-content:center;align-items:center;width:100%;height:100%;display:flex}._cellText_hfkay_11{transition:color .2s ease-in-out}._grid_1qk2p_1{grid-auto-rows:minmax(var(--dixa-size-spacer-500), 1fr);flex-grow:1;display:grid}._row_1qk2p_7{text-align:center;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;display:grid}._legend_1k9xu_54{position:relative}._trigger_1k9xu_58{position:absolute;top:-50%;right:0}._popover_1k9xu_64{width:256px;max-height:298px;padding:var(--dixa-size-spacer-300);z-index:100;box-sizing:border-box;background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);margin:0 var(--dixa-size-spacer-200);background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);overflow-y:auto}._breakdown_1k9xu_83{gap:var(--dixa-size-spacer-250);flex-direction:column;margin:0;padding:0;list-style:none;display:flex}._breakdown_1k9xu_83 li{gap:var(--dixa-size-spacer-200);grid-template-columns:1fr auto;display:grid}._breakdown_1k9xu_83 li>:first-child{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{opacity:0;width:100%;height:100%;position:absolute;top:0;left:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{white-space:nowrap;text-overflow:ellipsis;max-width:240px;position:relative;overflow:hidden}._tooltip_1xmkm_20{max-width:300px}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { Badge as e, Box as t, Button as n, ButtonGroup as r, ButtonList as i, Divider as a, EmptyState as o, FlexBox as s, HelpIcon as c, IconButton as l, Pagination as u, Table as d, Text as f, Tooltip as p } from "@dixa/lib-shared-habla";
import * as m from "react";
import { Fragment as h, cloneElement as g, createElement as _, memo as v, useCallback as y, useEffect as b, useLayoutEffect as x, useMemo as S, useRef as C, useState as w } from "react";
import { Fragment as T, jsx as E, jsxs as D } from "react/jsx-runtime";
import * as O from "react-dom";
import k from "classnames";
import { useInterval as A, useList as j, useMap as M, usePrevious as N, useUpdateEffect as P } from "react-use";
import { Area as ee, AreaChart as F, Bar as te, BarChart as ne, CartesianGrid as re, Cell as ie, Label as ae, LabelList as oe, Legend as se, Line as ce, LineChart as le, Pie as ue, PieChart as de, ReferenceLine as fe, ResponsiveContainer as pe, Sector as me, Tooltip as he, XAxis as ge, YAxis as _e } from "recharts";
import ve from "moment-timezone";
import { colors as ye, typography as be } from "@dixa/lib-shared-tokens";
import xe from "lodash/truncate";
import Se from "lodash/capitalize";
import Ce from "lodash/debounce";
import we from "lodash/last";
import Te from "lodash/pick";
import Ee from "lodash/sum";
import De from "lodash/isEqual";
import Oe from "lodash/isNumber";
import { TagChips as ke } from "lib-shared-tagging";
import Ae from "lodash/isNil";
import je from "lodash/orderBy";
// \0rolldown/runtime.js
var Me = Object.create, Ne = Object.defineProperty, Pe = Object.getOwnPropertyDescriptor, Fe = Object.getOwnPropertyNames, Ie = Object.getPrototypeOf, Le = Object.prototype.hasOwnProperty, Re = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, ze = (e, t) => () => (t || (e((t = { exports: {} }).exports, t, t.exports), e = null), t.exports), Be = (e, t) => {
	let n = {};
	for (var r in e) Ne(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Ne(n, Symbol.toStringTag, { value: "Module" }), n;
}, Ve = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Fe(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Le.call(e, s) && s !== n && Ne(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Pe(t, s)) || r.enumerable
	});
	return e;
}, He = (e, t, n) => (n = e == null ? {} : Me(Ie(e)), Ve(t || !e || !e.__esModule || !Le.call(e, "default") ? Ne(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Ue = (e) => Le.call(e, "module.exports") ? e["module.exports"] : Ve(Ne({}, "__esModule", { value: !0 }), e), We = Object.defineProperty, Ge = (e, t) => We(e, "name", {
	value: t,
	configurable: !0
}), Ke = !!(typeof window < "u" && window.document && window.document.createElement);
function qe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ Ge(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
Ge(qe, "composeEventHandlers");
function Je(e) {
	if (!Ke) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
Ge(Je, "getOwnerWindow");
function Ye(e) {
	if (!Ke) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
Ge(Ye, "getOwnerDocument");
function Xe(e, t = !1) {
	let { activeElement: n } = Ye(e);
	if (!n?.nodeName) return null;
	if (Ze(n) && n.contentDocument) return Xe(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = Ye(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
Ge(Xe, "getActiveElement");
function Ze(e) {
	return e.tagName === "IFRAME";
}
Ge(Ze, "isFrame");
// ../../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var Qe = Object.defineProperty, $e = (e, t) => Qe(e, "name", {
	value: t,
	configurable: !0
});
function et(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
$e(et, "setRef");
function tt(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = et(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : et(e[t], null);
			}
		};
	};
}
$e(tt, "composeRefs");
function nt(...e) {
	return m.useCallback(tt(...e), e);
}
$e(nt, "useComposedRefs");
// ../../../node_modules/@radix-ui/react-context/dist/index.mjs
var rt = Object.defineProperty, I = (e, t) => rt(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function it(e, t) {
	let n = m.createContext(t);
	n.displayName = e + "Context";
	let r = /* @__PURE__ */ I((e) => {
		let { children: t, ...r } = e, i = m.useMemo(() => r, Object.values(r));
		return /* @__PURE__ */ E(n.Provider, {
			value: i,
			children: t
		});
	}, "Provider");
	r.displayName = e + "Provider";
	function i(r, i = {}) {
		let { optional: a = !1 } = i, o = m.useContext(n);
		if (o) return o;
		if (t !== void 0) return t;
		if (!a) throw Error(`\`${r}\` must be used within \`${e}\``);
	}
	return I(i, "useContext"), [r, i];
}
I(it, "createContext");
// @__NO_SIDE_EFFECTS__
function at(e, t = []) {
	let n = [];
	function r(t, r) {
		let i = m.createContext(r);
		i.displayName = t + "Context";
		let a = n.length;
		n = [...n, r];
		let o = /* @__PURE__ */ I((t) => {
			let { scope: n, children: r, ...o } = t, s = n?.[e]?.[a] || i, c = m.useMemo(() => o, Object.values(o));
			return /* @__PURE__ */ E(s.Provider, {
				value: c,
				children: r
			});
		}, "Provider");
		o.displayName = t + "Provider";
		function s(n, o, s = {}) {
			let { optional: c = !1 } = s, l = o?.[e]?.[a] || i, u = m.useContext(l);
			if (u) return u;
			if (r !== void 0) return r;
			if (!c) throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return I(s, "useContext"), [o, s];
	}
	I(r, "createContext");
	let i = /* @__PURE__ */ I(() => {
		let t = n.map((e) => m.createContext(e));
		return /* @__PURE__ */ I(function(n) {
			let r = n?.[e] || t;
			return m.useMemo(() => ({ [`__scope${e}`]: {
				...n,
				[e]: r
			} }), [n, r]);
		}, "useScope");
	}, "createScope");
	return i.scopeName = e, [r, ot(i, ...t)];
}
I(at, "createContextScope");
function ot(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = /* @__PURE__ */ I(() => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ I(function(e) {
			let r = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return m.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
		}, "useComposedScopes");
	}, "createScope");
	return n.scopeName = t.scopeName, n;
}
I(ot, "composeContextScopes");
// ../../../node_modules/@radix-ui/react-slot/dist/index.mjs
var st = Object.defineProperty, L = (e, t) => st(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function ct(e) {
	let t = m.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		gt(r) && typeof bt == "function" && (r = bt(r._payload)), m.Children.forEach(r, (e) => {
			if (mt(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				gt(n) && typeof bt == "function" && (n = bt(n._payload)), a = dt(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = m.cloneElement(a, void 0, s) : !o && m.Children.count(r) === 1 && m.isValidElement(r) && (a = r);
		let c = a ? pt(a) : void 0, l = nt(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? yt(e) : vt(e));
			return r;
		}
		let u = ft(i, a.props ?? {});
		return a.type !== m.Fragment && (u.ref = n ? l : c), m.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
L(ct, "createSlot");
var lt = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function ut(e) {
	let t = /* @__PURE__ */ L((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = lt, t;
}
L(ut, "createSlottable");
var dt = /* @__PURE__ */ L((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return m.isValidElement(t) ? m.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return m.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function ft(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
L(ft, "mergeProps");
function pt(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
L(pt, "getElementRef");
function mt(e) {
	return m.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === lt;
}
L(mt, "isSlottable");
var ht = Symbol.for("react.lazy");
function gt(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === ht && "_payload" in e && _t(e._payload);
}
L(gt, "isLazyComponent");
function _t(e) {
	return typeof e == "object" && !!e && "then" in e;
}
L(_t, "isPromiseLike");
var vt = /* @__PURE__ */ L((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), yt = /* @__PURE__ */ L((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), bt = m.use, xt = Object.defineProperty, St = (e, t) => xt(e, "name", {
	value: t,
	configurable: !0
}), Ct = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /* @__PURE__ */ ct(`Primitive.${t}`), r = m.forwardRef((e, r) => {
		let { asChild: i, ...a } = e, o = i ? n : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ E(o, {
			...a,
			ref: r
		});
	});
	return r.displayName = `Primitive.${t}`, {
		...e,
		[t]: r
	};
}, {});
function wt(e, t) {
	e && O.flushSync(() => e.dispatchEvent(t));
}
St(wt, "dispatchDiscreteCustomEvent");
// ../../../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var Tt = Object.defineProperty, Et = (e, t) => Tt(e, "name", {
	value: t,
	configurable: !0
});
function Dt(e) {
	let t = m.useRef(e);
	return m.useEffect(() => {
		t.current = e;
	}), m.useMemo(() => ((...e) => t.current?.(...e)), []);
}
Et(Dt, "useCallbackRef");
// ../../../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var Ot = Object.defineProperty, R = (e, t) => Ot(e, "name", {
	value: t,
	configurable: !0
}), kt = "dismissableLayer.update", At = "dismissableLayer.pointerDownOutside", jt = "dismissableLayer.focusOutside", Mt, Nt = m.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), Pt = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ R(function(e, t) {
	let { disableOutsidePointerEvents: n = !1, deferPointerDownOutside: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...l } = e, u = m.useContext(Nt), [d, f] = m.useState(null), p = d?.ownerDocument ?? globalThis?.document, [, h] = m.useState({}), g = nt(t, f), _ = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), y = v ? _.indexOf(v) : -1, b = d ? _.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, S = b >= y, C = m.useRef(!1), w = Lt((e) => {
		a?.(e), s?.(e), e.defaultPrevented || c?.();
	}, {
		ownerDocument: p,
		deferPointerDownOutside: r,
		isDeferredPointerDownOutsideRef: C,
		dismissableSurfaces: u.dismissableSurfaces,
		shouldHandlePointerDownOutside: m.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...u.branches].some((t) => t.contains(e));
			return S && !t;
		}, [u.branches, S])
	}), T = Rt((e) => {
		if (r && C.current) return;
		let t = e.target;
		[...u.branches].some((e) => e.contains(t)) || (o?.(e), s?.(e), e.defaultPrevented || c?.());
	}, p), D = d ? b === _.length - 1 : !1, O = Dt((e) => {
		e.key === "Escape" && (i?.(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
	});
	return m.useEffect(() => {
		if (D) return p.addEventListener("keydown", O, { capture: !0 }), () => p.removeEventListener("keydown", O, { capture: !0 });
	}, [
		p,
		D,
		O
	]), m.useEffect(() => {
		if (d) return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Mt = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), zt(), () => {
			n && (u.layersWithOutsidePointerEventsDisabled.delete(d), u.layersWithOutsidePointerEventsDisabled.size === 0 && (p.body.style.pointerEvents = Mt));
		};
	}, [
		d,
		p,
		n,
		u
	]), m.useEffect(() => () => {
		d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), zt());
	}, [d, u]), m.useEffect(() => {
		let e = /* @__PURE__ */ R(() => h({}), "handleUpdate");
		return document.addEventListener(kt, e), () => document.removeEventListener(kt, e);
	}, []), /* @__PURE__ */ E(Ct.div, {
		...l,
		ref: g,
		style: {
			pointerEvents: x ? S ? "auto" : "none" : void 0,
			...e.style
		},
		onFocusCapture: qe(e.onFocusCapture, T.onFocusCapture),
		onBlurCapture: qe(e.onBlurCapture, T.onBlurCapture),
		onPointerDownCapture: qe(e.onPointerDownCapture, w.onPointerDownCapture)
	});
}, "DismissableLayer"));
function Ft() {
	let e = m.useContext(Nt), [t, n] = m.useState(null);
	return m.useEffect(() => {
		if (t) return e.dismissableSurfaces.add(t), () => {
			e.dismissableSurfaces.delete(t);
		};
	}, [t, e.dismissableSurfaces]), n;
}
R(Ft, "useDismissableLayerSurface");
var It = /* @__PURE__ */ R(() => !0, "IS_TRUE");
function Lt(e, t) {
	let { ownerDocument: n = globalThis?.document, deferPointerDownOutside: r = !1, isDeferredPointerDownOutsideRef: i, dismissableSurfaces: a, shouldHandlePointerDownOutside: o = It } = t, s = Dt(e), c = m.useRef(!1), l = m.useRef(!1), u = m.useRef(/* @__PURE__ */ new Map()), d = m.useRef(() => {});
	return m.useEffect(() => {
		function e() {
			l.current = !1, i.current = !1, u.current.clear();
		}
		R(e, "resetOutsideInteraction");
		function t() {
			return Array.from(u.current.values()).some(Boolean);
		}
		R(t, "isOutsideInteractionIntercepted");
		function f(e) {
			if (!l.current) return;
			let t = e.target;
			t instanceof Node && [...a].some((e) => e.contains(t)) || u.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				l.current && d.current();
			}, 0);
		}
		R(f, "handleInteractionCapture");
		function p(e) {
			l.current && u.current.set(e.type, !1);
		}
		R(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ R((a) => {
			if (a.target && !c.current) {
				let f = function() {
					n.removeEventListener("click", d.current);
					let r = t();
					e(), r || Bt(At, s, p, { discrete: !0 });
				};
				if (R(f, "handleAndDispatchPointerDownOutsideEvent"), !o(a.target)) {
					n.removeEventListener("click", d.current), e(), c.current = !1;
					return;
				}
				let p = { originalEvent: a };
				l.current = !0, i.current = r && a.button === 0, u.current.clear(), !r || a.button !== 0 ? f() : (n.removeEventListener("click", d.current), d.current = f, n.addEventListener("click", d.current, { once: !0 }));
			} else n.removeEventListener("click", d.current), e();
			c.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) n.addEventListener(e, f, !0), n.addEventListener(e, p);
		let g = window.setTimeout(() => {
			n.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), n.removeEventListener("pointerdown", m), n.removeEventListener("click", d.current);
			for (let e of h) n.removeEventListener(e, f, !0), n.removeEventListener(e, p);
		};
	}, [
		n,
		s,
		r,
		i,
		a,
		o
	]), { onPointerDownCapture: /* @__PURE__ */ R(() => c.current = !0, "onPointerDownCapture") };
}
R(Lt, "usePointerDownOutside");
function Rt(e, t = globalThis?.document) {
	let n = Dt(e), r = m.useRef(!1);
	return m.useEffect(() => {
		let e = /* @__PURE__ */ R((e) => {
			e.target && !r.current && Bt(jt, n, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e);
	}, [t, n]), {
		onFocusCapture: /* @__PURE__ */ R(() => r.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ R(() => r.current = !1, "onBlurCapture")
	};
}
R(Rt, "useFocusOutside");
function zt() {
	let e = new CustomEvent(kt);
	document.dispatchEvent(e);
}
R(zt, "dispatchUpdate");
function Bt(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? wt(i, a) : i.dispatchEvent(a);
}
R(Bt, "handleAndDispatchCustomEvent");
// ../../../node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var Vt = Object.defineProperty, Ht = (e, t) => Vt(e, "name", {
	value: t,
	configurable: !0
}), Ut = 0, Wt = null;
function Gt(e) {
	return Kt(), e.children;
}
Ht(Gt, "FocusGuards");
function Kt() {
	m.useEffect(() => {
		Wt ||= {
			start: qt(),
			end: qt()
		};
		let { start: e, end: t } = Wt;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), Ut++, () => {
			Ut === 1 && (Wt?.start.remove(), Wt?.end.remove(), Wt = null), Ut = Math.max(0, Ut - 1);
		};
	}, []);
}
Ht(Kt, "useFocusGuards");
function qt() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Ht(qt, "createFocusGuard");
// ../../../node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var Jt = Object.defineProperty, z = (e, t) => Jt(e, "name", {
	value: t,
	configurable: !0
}), Yt = "focusScope.autoFocusOnMount", Xt = "focusScope.autoFocusOnUnmount", Zt = {
	bubbles: !1,
	cancelable: !0
}, Qt = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ z(function(e, t) {
	let { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: a, ...o } = e, [s, c] = m.useState(null), l = Dt(i), u = Dt(a), d = m.useRef(null), f = nt(t, c), p = m.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	m.useEffect(() => {
		if (r) {
			let e = function(e) {
				if (p.paused || !s) return;
				let t = e.target;
				s.contains(t) ? d.current = t : B(d.current, { select: !0 });
			}, t = function(e) {
				if (p.paused || !s) return;
				let t = e.relatedTarget;
				t !== null && (s.contains(t) || B(d.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && B(s);
			};
			z(e, "handleFocusIn"), z(t, "handleFocusOut"), z(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return s && r.observe(s, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		r,
		s,
		p.paused
	]), m.useEffect(() => {
		if (s) {
			on.add(p);
			let e = document.activeElement;
			if (!s.contains(e)) {
				let t = new CustomEvent(Yt, Zt);
				s.addEventListener(Yt, l), s.dispatchEvent(t), t.defaultPrevented || ($t(ln(tn(s)), { select: !0 }), document.activeElement === e && B(s));
			}
			return () => {
				s.removeEventListener(Yt, l), setTimeout(() => {
					let t = new CustomEvent(Xt, Zt);
					s.addEventListener(Xt, u), s.dispatchEvent(t), t.defaultPrevented || B(e ?? document.body, { select: !0 }), s.removeEventListener(Xt, u), on.remove(p);
				}, 0);
			};
		}
	}, [
		s,
		l,
		u,
		p
	]);
	let h = m.useCallback((e) => {
		if (!n && !r || p.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, i = document.activeElement;
		if (t && i) {
			let t = e.currentTarget, [r, a] = en(t);
			r && a ? !e.shiftKey && i === a ? (e.preventDefault(), n && B(r, { select: !0 })) : e.shiftKey && i === r && (e.preventDefault(), n && B(a, { select: !0 })) : i === t && e.preventDefault();
		}
	}, [
		n,
		r,
		p.paused
	]);
	return /* @__PURE__ */ E(Ct.div, {
		tabIndex: -1,
		...o,
		ref: f,
		onKeyDown: h
	});
}, "FocusScope"));
function $t(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (B(r, { select: t }), document.activeElement !== n) return;
}
z($t, "focusFirst");
function en(e) {
	let t = tn(e);
	return [nn(t, e), nn(t.reverse(), e)];
}
z(en, "getTabbableEdges");
function tn(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ z((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
z(tn, "getTabbableCandidates");
function nn(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : rn(r, { upTo: t }))) return r;
}
z(nn, "findVisible");
function rn(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
z(rn, "isHidden");
function an(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
z(an, "isSelectableInput");
function B(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && an(e) && t && e.select();
	}
}
z(B, "focus");
var on = sn();
function sn() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = cn(e, t), e.unshift(t);
		},
		remove(t) {
			e = cn(e, t), e[0]?.resume();
		}
	};
}
z(sn, "createFocusScopesStack");
function cn(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
z(cn, "arrayRemove");
function ln(e) {
	return e.filter((e) => e.tagName !== "A");
}
z(ln, "removeLinks");
// ../../../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var V = globalThis?.document ? m.useLayoutEffect : () => {}, un = Object.defineProperty, dn = (e, t) => un(e, "name", {
	value: t,
	configurable: !0
}), fn = m.useId || (() => void 0), pn = 0;
function mn(e) {
	let [t, n] = m.useState(fn());
	return V(() => {
		e || n((e) => e ?? String(pn++));
	}, [e]), e || (t ? `radix-${t}` : "");
}
dn(mn, "useId");
// ../../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var hn = [
	"top",
	"right",
	"bottom",
	"left"
], gn = Math.min, H = Math.max, _n = Math.round, vn = Math.floor, U = (e) => ({
	x: e,
	y: e
}), yn = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function bn(e, t, n) {
	return H(e, gn(t, n));
}
function W(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function G(e) {
	return e.split("-")[0];
}
function xn(e) {
	return e.split("-")[1];
}
function Sn(e) {
	return e === "x" ? "y" : "x";
}
function Cn(e) {
	return e === "y" ? "height" : "width";
}
function K(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function wn(e) {
	return Sn(K(e));
}
function Tn(e, t, n) {
	n === void 0 && (n = !1);
	let r = xn(e), i = wn(e), a = Cn(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = Pn(o)), [o, Pn(o)];
}
function En(e) {
	let t = Pn(e);
	return [
		Dn(e),
		t,
		Dn(t)
	];
}
function Dn(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var On = ["left", "right"], kn = ["right", "left"], An = ["top", "bottom"], jn = ["bottom", "top"];
function Mn(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? kn : On : t ? On : kn;
		case "left":
		case "right": return t ? An : jn;
		default: return [];
	}
}
function Nn(e, t, n, r) {
	let i = xn(e), a = Mn(G(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(Dn)))), a;
}
function Pn(e) {
	let t = G(e);
	return yn[t] + e.slice(t.length);
}
function Fn(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function In(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : Fn(e);
}
function Ln(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
// ../../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Rn(e, t, n) {
	let { reference: r, floating: i } = e, a = K(t), o = wn(t), s = Cn(o), c = G(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (xn(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end": p[o] += f * (n && l ? -1 : 1);
	}
	return p;
}
async function zn(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = W(t, e), p = In(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Ln(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Ln(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Bn = 50, Vn = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: zn
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Rn(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < Bn && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = Rn(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, Hn = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = W(e, t) || {};
		if (l == null) return {};
		let d = In(u), f = {
			x: n,
			y: r
		}, p = wn(i), m = Cn(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		C && await (o.isElement == null ? void 0 : o.isElement(S)) || (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = gn(d[_], T), D = gn(d[v], T), O = E, k = C - h[m] - D, A = C / 2 - h[m] / 2 + w, j = bn(O, A, k), M = !c.arrow && xn(i) != null && A !== j && a.reference[m] / 2 - (A < O ? E : D) - h[m] / 2 < 0, N = M ? A < O ? A - O : A - k : 0;
		return {
			[p]: f[p] + N,
			data: {
				[p]: j,
				centerOffset: A - j - N,
				...M && { alignmentOffset: N }
			},
			reset: M
		};
	}
}), Un = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = W(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = G(r), _ = K(o), v = G(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [Pn(o)] : En(o)), x = p !== "none";
			!d && x && b.push(...Nn(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = Tn(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === K(t) || T.every((e) => K(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = K(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function Wn(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function Gn(e) {
	return hn.some((t) => e[t] >= 0);
}
var Kn = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n, platform: r } = t, { strategy: i = "referenceHidden", ...a } = W(e, t);
			switch (i) {
				case "referenceHidden": {
					let e = Wn(await r.detectOverflow(t, {
						...a,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: Gn(e)
					} };
				}
				case "escaped": {
					let e = Wn(await r.detectOverflow(t, {
						...a,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: Gn(e)
					} };
				}
				default: return {};
			}
		}
	};
}, qn = /*#__PURE__*/ new Set(["left", "top"]);
async function Jn(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = G(n), s = xn(n), c = K(n) === "y", l = qn.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = W(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Yn = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Jn(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, Xn = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = W(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = K(G(i)), p = Sn(f), m = u[p], h = u[f];
			if (o) {
				let e = p === "y" ? "top" : "left", t = p === "y" ? "bottom" : "right", n = m + d[e], r = m - d[t];
				m = bn(n, m, r);
			}
			if (s) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = h + d[e], r = h - d[t];
				h = bn(n, h, r);
			}
			let g = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				...g,
				data: {
					x: g.x - n,
					y: g.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
}, Zn = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = W(e, t), u = {
				x: n,
				y: r
			}, d = K(i), f = Sn(d), p = u[f], m = u[d], h = W(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: 0,
				crossAxis: 0,
				...h
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = qn.has(G(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, Qn = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			var n, r;
			let { placement: i, rects: a, platform: o, elements: s } = t, { apply: c = () => {}, ...l } = W(e, t), u = await o.detectOverflow(t, l), d = G(i), f = xn(i), p = K(i) === "y", { width: m, height: h } = a.floating, g, _;
			d === "top" || d === "bottom" ? (g = d, _ = f === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, g = f === "end" ? "top" : "bottom");
			let v = h - u.top - u.bottom, y = m - u.left - u.right, b = gn(h - u[g], v), x = gn(m - u[_], y), S = !t.middlewareData.shift, C = b, w = x;
			if ((n = t.middlewareData.shift) != null && n.enabled.x && (w = y), (r = t.middlewareData.shift) != null && r.enabled.y && (C = v), S && !f) {
				let e = H(u.left, 0), t = H(u.right, 0), n = H(u.top, 0), r = H(u.bottom, 0);
				p ? w = m - 2 * (e !== 0 || t !== 0 ? e + t : H(u.left, u.right)) : C = h - 2 * (n !== 0 || r !== 0 ? n + r : H(u.top, u.bottom));
			}
			await c({
				...t,
				availableWidth: w,
				availableHeight: C
			});
			let T = await o.getDimensions(s.floating);
			return m !== T.width || h !== T.height ? { reset: { rects: !0 } } : {};
		}
	};
};
// ../../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function $n() {
	return typeof window < "u";
}
function er(e) {
	return tr(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function q(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function J(e) {
	return ((tr(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function tr(e) {
	return $n() ? e instanceof Node || e instanceof q(e).Node : !1;
}
function Y(e) {
	return $n() ? e instanceof Element || e instanceof q(e).Element : !1;
}
function X(e) {
	return $n() ? e instanceof HTMLElement || e instanceof q(e).HTMLElement : !1;
}
function nr(e) {
	return !$n() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof q(e).ShadowRoot;
}
function rr(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Z(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function ir(e) {
	return /^(table|td|th)$/.test(er(e));
}
function ar(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var or = /transform|translate|scale|rotate|perspective|filter/, sr = /paint|layout|strict|content/, cr = (e) => !!e && e !== "none", lr;
function ur(e) {
	let t = Y(e) ? Z(e) : e;
	return cr(t.transform) || cr(t.translate) || cr(t.scale) || cr(t.rotate) || cr(t.perspective) || !fr() && (cr(t.backdropFilter) || cr(t.filter)) || or.test(t.willChange || "") || sr.test(t.contain || "");
}
function dr(e) {
	let t = hr(e);
	for (; X(t) && !pr(t);) {
		if (ur(t)) return t;
		if (ar(t)) return null;
		t = hr(t);
	}
	return null;
}
function fr() {
	return lr ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), lr;
}
function pr(e) {
	return /^(html|body|#document)$/.test(er(e));
}
function Z(e) {
	return q(e).getComputedStyle(e);
}
function mr(e) {
	return Y(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function hr(e) {
	if (er(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || nr(e) && e.host || J(e);
	return nr(t) ? t.host : t;
}
function gr(e) {
	let t = hr(e);
	return pr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : X(t) && rr(t) ? t : gr(t);
}
function _r(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = gr(e), i = r === e.ownerDocument?.body, a = q(r);
	if (i) {
		let e = vr(a);
		return t.concat(a, a.visualViewport || [], rr(r) ? r : [], e && n ? _r(e) : []);
	}
	return t.concat(r, _r(r, [], n));
}
function vr(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
// ../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function yr(e) {
	let t = Z(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = X(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = _n(n) !== a || _n(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function br(e) {
	return Y(e) ? e : e.contextElement;
}
function xr(e) {
	let t = br(e);
	if (!X(t)) return U(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = yr(t), o = (a ? _n(n.width) : n.width) / r, s = (a ? _n(n.height) : n.height) / i;
	return o && Number.isFinite(o) || (o = 1), s && Number.isFinite(s) || (s = 1), {
		x: o,
		y: s
	};
}
var Sr = /*#__PURE__*/ U(0);
function Cr(e) {
	let t = q(e);
	return !fr() || !t.visualViewport ? Sr : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function wr(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== q(e) ? !1 : t;
}
function Tr(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = br(e), o = U(1);
	t && (r ? Y(r) && (o = xr(r)) : o = xr(e));
	let s = wr(a, n, r) ? Cr(a) : U(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = q(a), t = r && Y(r) ? q(r) : r, n = e, i = vr(n);
		for (; i && r && t !== n;) {
			let e = xr(i), t = i.getBoundingClientRect(), r = Z(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = q(i), i = vr(n);
		}
	}
	return Ln({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function Er(e, t) {
	let n = mr(e).scrollLeft;
	return t ? t.left + n : Tr(J(e)).left + n;
}
function Dr(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - Er(e, n),
		y: n.top + t.scrollTop
	};
}
function Or(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = J(r), s = t ? ar(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = U(1), u = U(0), d = X(r);
	if ((d || !d && !a) && ((er(r) !== "body" || rr(o)) && (c = mr(r)), d)) {
		let e = Tr(r);
		l = xr(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? Dr(o, c) : U(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function kr(e) {
	return Array.from(e.getClientRects());
}
function Ar(e) {
	let t = J(e), n = mr(e), r = e.ownerDocument.body, i = H(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = H(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + Er(e), s = -n.scrollTop;
	return Z(r).direction === "rtl" && (o += H(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var jr = 25;
function Mr(e, t) {
	let n = q(e), r = J(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = fr();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = Er(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= jr && (a -= o);
	} else l <= jr && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
function Nr(e, t) {
	let n = Tr(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = X(e) ? xr(e) : U(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function Pr(e, t, n) {
	let r;
	if (t === "viewport") r = Mr(e, n);
	else if (t === "document") r = Ar(J(e));
	else if (Y(t)) r = Nr(t, n);
	else {
		let n = Cr(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Ln(r);
}
function Fr(e, t) {
	let n = hr(e);
	return n === t || !Y(n) || pr(n) ? !1 : Z(n).position === "fixed" || Fr(n, t);
}
function Ir(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = _r(e, [], !1).filter((e) => Y(e) && er(e) !== "body"), i = null, a = Z(e).position === "fixed", o = a ? hr(e) : e;
	for (; Y(o) && !pr(o);) {
		let t = Z(o), n = ur(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && (i.position === "absolute" || i.position === "fixed") || rr(o) && !n && Fr(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = hr(o);
	}
	return t.set(e, r), r;
}
function Lr(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? ar(t) ? [] : Ir(t, this._c) : [].concat(n), r], o = Pr(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = Pr(t, a[e], i);
		s = H(n.top, s), c = gn(n.right, c), l = gn(n.bottom, l), u = H(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function Rr(e) {
	let { width: t, height: n } = yr(e);
	return {
		width: t,
		height: n
	};
}
function zr(e, t, n) {
	let r = X(t), i = J(t), a = n === "fixed", o = Tr(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = U(0);
	function l() {
		c.x = Er(i);
	}
	if (r || !r && !a) {
		if ((er(t) !== "body" || rr(i)) && (s = mr(t)), r) {
			let e = Tr(t, !0, a, t);
			c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
		} else i && l();
	}
	a && !r && i && l();
	let u = i && !r && !a ? Dr(i, s) : U(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function Br(e) {
	return Z(e).position === "static";
}
function Vr(e, t) {
	if (!X(e) || Z(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return J(e) === n && (n = n.ownerDocument.body), n;
}
function Hr(e, t) {
	let n = q(e);
	if (ar(e)) return n;
	if (!X(e)) {
		let t = hr(e);
		for (; t && !pr(t);) {
			if (Y(t) && !Br(t)) return t;
			t = hr(t);
		}
		return n;
	}
	let r = Vr(e, t);
	for (; r && ir(r) && Br(r);) r = Vr(r, t);
	return r && pr(r) && Br(r) && !ur(r) ? n : r || dr(e) || n;
}
var Ur = async function(e) {
	let t = this.getOffsetParent || Hr, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: zr(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function Wr(e) {
	return Z(e).direction === "rtl";
}
var Gr = {
	convertOffsetParentRelativeRectToViewportRelativeRect: Or,
	getDocumentElement: J,
	getClippingRect: Lr,
	getOffsetParent: Hr,
	getElementRects: Ur,
	getClientRects: kr,
	getDimensions: Rr,
	getScale: xr,
	isElement: Y,
	isRTL: Wr
};
function Kr(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function qr(e, t) {
	let n = null, r, i = J(e);
	function a() {
		var e;
		clearTimeout(r), (e = n) == null || e.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (s || t(), !f || !p) return;
		let m = vn(d), h = vn(i.clientWidth - (u + f)), g = vn(i.clientHeight - (d + p)), _ = vn(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: H(0, gn(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (n !== c) {
				if (!y) return o();
				n ? o(!1, n) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 1e3);
			}
			n === 1 && !Kr(l, e.getBoundingClientRect()) && o(), y = !1;
		}
		try {
			n = new IntersectionObserver(b, {
				...v,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(b, v);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function Jr(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = br(e), u = i || a ? [...l ? _r(l) : [], ...t ? _r(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? qr(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? Tr(e) : null;
	c && g();
	function g() {
		let t = Tr(e);
		h && !Kr(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Yr = Yn, Xr = Xn, Zr = Un, Qr = Qn, $r = Kn, ei = Hn, ti = Zn, ni = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: Gr,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return Vn(e, t, {
		...i,
		platform: a
	});
}, ri = typeof document < "u" ? x : function() {};
function ii(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!ii(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !ii(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function ai(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function oi(e, t) {
	let n = ai(e);
	return Math.round(t * n) / n;
}
function si(e) {
	let t = m.useRef(e);
	return ri(() => {
		t.current = e;
	}), t;
}
function ci(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: r = [], platform: i, elements: { reference: a, floating: o } = {}, transform: s = !0, whileElementsMounted: c, open: l } = e, [u, d] = m.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [f, p] = m.useState(r);
	ii(f, r) || p(r);
	let [h, g] = m.useState(null), [_, v] = m.useState(null), y = m.useCallback((e) => {
		e !== C.current && (C.current = e, g(e));
	}, []), b = m.useCallback((e) => {
		e !== w.current && (w.current = e, v(e));
	}, []), x = a || h, S = o || _, C = m.useRef(null), w = m.useRef(null), T = m.useRef(u), E = c != null, D = si(c), k = si(i), A = si(l), j = m.useCallback(() => {
		if (!C.current || !w.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: f
		};
		k.current && (e.platform = k.current), ni(C.current, w.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: A.current !== !1
			};
			M.current && !ii(T.current, t) && (T.current = t, O.flushSync(() => {
				d(t);
			}));
		});
	}, [
		f,
		t,
		n,
		k,
		A
	]);
	ri(() => {
		l === !1 && T.current.isPositioned && (T.current.isPositioned = !1, d((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [l]);
	let M = m.useRef(!1);
	ri(() => (M.current = !0, () => {
		M.current = !1;
	}), []), ri(() => {
		if (x && (C.current = x), S && (w.current = S), x && S) {
			if (D.current) return D.current(x, S, j);
			j();
		}
	}, [
		x,
		S,
		j,
		D,
		E
	]);
	let N = m.useMemo(() => ({
		reference: C,
		floating: w,
		setReference: y,
		setFloating: b
	}), [y, b]), P = m.useMemo(() => ({
		reference: x,
		floating: S
	}), [x, S]), ee = m.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!P.floating) return e;
		let t = oi(P.floating, u.x), r = oi(P.floating, u.y);
		return s ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...ai(P.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		s,
		P.floating,
		u.x,
		u.y
	]);
	return m.useMemo(() => ({
		...u,
		update: j,
		refs: N,
		elements: P,
		floatingStyles: ee
	}), [
		u,
		j,
		N,
		P,
		ee
	]);
}
var li = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : ei({
				element: r.current,
				padding: i
			}).fn(n) : r ? ei({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, ui = (e, t) => {
	let n = Yr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, di = (e, t) => {
	let n = Xr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, fi = (e, t) => ({
	fn: ti(e).fn,
	options: [e, t]
}), pi = (e, t) => {
	let n = Zr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, mi = (e, t) => {
	let n = Qr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, hi = (e, t) => {
	let n = $r(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, gi = (e, t) => {
	let n = li(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, _i = Object.defineProperty, vi = (e, t) => _i(e, "name", {
	value: t,
	configurable: !0
});
function yi(e) {
	let [t, n] = m.useState(void 0);
	return V(() => {
		if (e) {
			n({
				width: e.offsetWidth,
				height: e.offsetHeight
			});
			let t = new ResizeObserver((t) => {
				if (!Array.isArray(t) || !t.length) return;
				let r = t[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = e.offsetWidth, a = e.offsetHeight;
				n({
					width: i,
					height: a
				});
			});
			return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
		}
		n(void 0);
	}, [e]), t;
}
vi(yi, "useSize");
// ../../../node_modules/@radix-ui/react-popper/dist/index.mjs
var bi = Object.defineProperty, xi = (e, t) => bi(e, "name", {
	value: t,
	configurable: !0
}), Si = "Popper", [Ci, wi] = /* @__PURE__ */ at(Si), [Ti, Ei] = Ci(Si), Di = /* @__PURE__ */ xi((e) => {
	let { __scopePopper: t, children: n } = e, [r, i] = m.useState(null), [a, o] = m.useState(void 0);
	return /* @__PURE__ */ E(Ti, {
		scope: t,
		anchor: r,
		onAnchorChange: i,
		placementState: a,
		setPlacementState: o,
		children: n
	});
}, "Popper"), Oi = "PopperAnchor", ki = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ xi(function(e, t) {
	let { __scopePopper: n, virtualRef: r, ...i } = e, a = Ei(Oi, n), o = m.useRef(null), s = a.onAnchorChange, c = nt(t, m.useCallback((e) => {
		o.current = e, e && s(e);
	}, [s])), l = m.useRef(null);
	m.useEffect(() => {
		if (!r) return;
		let e = l.current;
		l.current = r.current, e !== l.current && s(l.current);
	});
	let u = a.placementState && Ii(a.placementState), d = u?.[0], f = u?.[1];
	return r ? null : /* @__PURE__ */ E(Ct.div, {
		"data-radix-popper-side": d,
		"data-radix-popper-align": f,
		...i,
		ref: c
	});
}, "PopperAnchor")), Ai = "PopperContent", [ji, Mi] = Ci(Ai), Ni = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ xi(function(e, t) {
	let { __scopePopper: n, side: r = "bottom", sideOffset: i = 0, align: a = "center", alignOffset: o = 0, arrowPadding: s = 0, avoidCollisions: c = !0, collisionBoundary: l = [], collisionPadding: u = 0, sticky: d = "partial", hideWhenDetached: f = !1, updatePositionStrategy: p = "optimized", onPlaced: h, ...g } = e, _ = Ei(Ai, n), [v, y] = m.useState(null), b = nt(t, y), [x, S] = m.useState(null), C = yi(x), w = C?.width ?? 0, T = C?.height ?? 0, D = r + (a === "center" ? "" : "-" + a), O = typeof u == "number" ? u : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...u
	}, k = Array.isArray(l) ? l : [l], A = k.length > 0, j = {
		padding: O,
		boundary: k.filter(Pi),
		altBoundary: A
	}, { refs: M, floatingStyles: N, placement: P, isPositioned: ee, middlewareData: F } = ci({
		strategy: "fixed",
		placement: D,
		whileElementsMounted: /* @__PURE__ */ xi((...e) => Jr(...e, { animationFrame: p === "always" }), "whileElementsMounted"),
		elements: { reference: _.anchor },
		middleware: [
			ui({
				mainAxis: i + T,
				alignmentAxis: o
			}),
			c && di({
				mainAxis: !0,
				crossAxis: !1,
				limiter: d === "partial" ? fi() : void 0,
				...j
			}),
			c && pi({ ...j }),
			mi({
				...j,
				apply: /* @__PURE__ */ xi(({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}, "apply")
			}),
			x && gi({
				element: x,
				padding: s
			}),
			Fi({
				arrowWidth: w,
				arrowHeight: T
			}),
			f && hi({
				strategy: "referenceHidden",
				...j,
				boundary: A ? j.boundary : void 0
			})
		]
	}), te = _.setPlacementState;
	V(() => (te(P), () => {
		te(void 0);
	}), [P, te]);
	let [ne, re] = Ii(P), ie = Dt(h);
	V(() => {
		ee && ie?.();
	}, [ee, ie]);
	let ae = F.arrow?.x, oe = F.arrow?.y, se = F.arrow?.centerOffset !== 0, [ce, le] = m.useState();
	return V(() => {
		v && le(window.getComputedStyle(v).zIndex);
	}, [v]), /* @__PURE__ */ E("div", {
		ref: M.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...N,
			transform: ee ? N.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: ce,
			"--radix-popper-transform-origin": [F.transformOrigin?.x, F.transformOrigin?.y].join(" "),
			...F.hide?.referenceHidden && {
				visibility: "hidden",
				pointerEvents: "none"
			}
		},
		dir: e.dir,
		children: /* @__PURE__ */ E(ji, {
			scope: n,
			placedSide: ne,
			placedAlign: re,
			onArrowChange: S,
			arrowX: ae,
			arrowY: oe,
			shouldHideArrow: se,
			children: /* @__PURE__ */ E(Ct.div, {
				"data-side": ne,
				"data-align": re,
				...g,
				ref: b,
				style: {
					...g.style,
					animation: ee ? g.style?.animation : "none"
				}
			})
		})
	});
}, "PopperContent"));
function Pi(e) {
	return e !== null;
}
xi(Pi, "isNotNull");
var Fi = /* @__PURE__ */ xi((e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = Ii(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
}), "transformOrigin");
function Ii(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
xi(Ii, "getSideAndAlignFromPlacement");
var Li = Di, Ri = ki, zi = Ni, Bi = Object.defineProperty, Vi = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ ((e, t) => Bi(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { container: n, ...r } = e, [i, a] = m.useState(!1);
	V(() => a(!0), []);
	let o = n || i && globalThis?.document?.body;
	return o ? O.createPortal(/* @__PURE__ */ E(Ct.div, {
		...r,
		ref: t
	}), o) : null;
}, "Portal")), Hi = Object.defineProperty, Ui = (e, t) => Hi(e, "name", {
	value: t,
	configurable: !0
});
function Wi(e, t) {
	return m.useReducer((e, n) => t[e][n] ?? e, e);
}
Ui(Wi, "useStateMachine");
var Gi = /* @__PURE__ */ Ui((e) => {
	let { present: t, children: n } = e, r = Ki(t), i = typeof n == "function" ? n({ present: r.isPresent }) : m.Children.only(n), a = Ji(r.ref, Xi(i));
	return typeof n == "function" || r.isPresent ? m.cloneElement(i, { ref: a }) : null;
}, "Presence");
function Ki(e) {
	let [t, n] = m.useState(), r = m.useRef(null), i = m.useRef(e), a = m.useRef("none"), o = m.useRef(void 0), [s, c] = Wi(e ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return m.useEffect(() => {
		s === "mounted" ? (a.current = o.current ?? Yi(r.current), o.current = void 0) : a.current = "none";
	}, [s]), V(() => {
		let t = r.current, n = i.current;
		if (n !== e) {
			let r = a.current, s = Yi(t);
			e ? (o.current = s, c("MOUNT")) : s === "none" || t?.display === "none" ? c("UNMOUNT") : c(n && r !== s ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
		}
	}, [e, c]), V(() => {
		if (t) {
			let e, n = t.ownerDocument.defaultView ?? window, o = /* @__PURE__ */ Ui((a) => {
				let o = Yi(r.current).includes(CSS.escape(a.animationName));
				if (a.target === t && o && (c("ANIMATION_END"), !i.current)) {
					let r = t.style.animationFillMode;
					t.style.animationFillMode = "forwards", e = n.setTimeout(() => {
						t.style.animationFillMode === "forwards" && (t.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ Ui((e) => {
				e.target === t && (a.current = Yi(r.current));
			}, "handleAnimationStart");
			return t.addEventListener("animationstart", s), t.addEventListener("animationcancel", o), t.addEventListener("animationend", o), () => {
				n.clearTimeout(e), t.removeEventListener("animationstart", s), t.removeEventListener("animationcancel", o), t.removeEventListener("animationend", o);
			};
		}
		c("ANIMATION_END");
	}, [t, c]), {
		isPresent: ["mounted", "unmountSuspended"].includes(s),
		ref: m.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				r.current = t, o.current = Yi(t);
			} else r.current = null;
			n(e);
		}, [])
	};
}
Ui(Ki, "usePresence");
function qi(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Ui(qi, "setRef");
function Ji(...e) {
	let t = m.useRef(e);
	return t.current = e, m.useCallback((e) => {
		let n = t.current, r = !1, i = n.map((t) => {
			let n = qi(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let t = i[e];
				typeof t == "function" ? t() : qi(n[e], null);
			}
		};
	}, []);
}
Ui(Ji, "useStableComposedRefs");
function Yi(e) {
	return e?.animationName || "none";
}
Ui(Yi, "getAnimationName");
function Xi(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Ui(Xi, "getElementRef");
// ../../../node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var Zi = Object.defineProperty, Qi = (e, t) => Zi(e, "name", {
	value: t,
	configurable: !0
}), $i = m.useEffectEvent, ea = m.useInsertionEffect;
function ta(e) {
	if (typeof $i == "function") return $i(e);
	let t = m.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof ea == "function" ? ea(() => {
		t.current = e;
	}) : V(() => {
		t.current = e;
	}), m.useMemo(() => ((...e) => t.current?.(...e)), []);
}
Qi(ta, "useEffectEvent");
// ../../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var na = Object.defineProperty, ra = (e, t) => na(e, "name", {
	value: t,
	configurable: !0
}), ia = m.useInsertionEffect || V;
function aa({ prop: e, defaultProp: t, onChange: n = /* @__PURE__ */ ra(() => {}, "onChange"), caller: r }) {
	let [i, a, o] = oa({
		defaultProp: t,
		onChange: n
	}), s = e !== void 0;
	return [s ? e : i, m.useCallback((t) => {
		if (s) {
			let n = sa(t) ? t(e) : t;
			n !== e && o.current?.(n);
		} else a(t);
	}, [
		s,
		e,
		a,
		o
	])];
}
ra(aa, "useControllableState");
function oa({ defaultProp: e, onChange: t }) {
	let [n, r] = m.useState(e), i = m.useRef(n), a = m.useRef(t);
	return ia(() => {
		a.current = t;
	}, [t]), m.useEffect(() => {
		i.current !== n && (a.current?.(n), i.current = n);
	}, [n, i]), [
		n,
		r,
		a
	];
}
ra(oa, "useUncontrolledState");
function sa(e) {
	return typeof e == "function";
}
ra(sa, "isFunction");
var ca = Symbol("RADIX:SYNC_STATE");
function la(e, t, n, r) {
	let { prop: i, defaultProp: a, onChange: o, caller: s } = t, c = i !== void 0, l = ta(o), u = [{
		...n,
		state: a
	}];
	r && u.push(r);
	let [d, f] = m.useReducer((t, n) => {
		if (n.type === ca) return {
			...t,
			state: n.state
		};
		let r = e(t, n);
		return c && !Object.is(r.state, t.state) && l(r.state), r;
	}, ...u), p = d.state, h = m.useRef(p);
	m.useEffect(() => {
		h.current !== p && (h.current = p, c || l(p));
	}, [
		p,
		h,
		c
	]);
	let g = m.useMemo(() => i === void 0 ? d : {
		...d,
		state: i
	}, [d, i]);
	return m.useEffect(() => {
		c && !Object.is(i, d.state) && f({
			type: ca,
			state: i
		});
	}, [
		i,
		d.state,
		c
	]), [g, f];
}
ra(la, "useControllableStateReducer");
// ../../../node_modules/aria-hidden/dist/es2015/index.js
var ua = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, da = /* @__PURE__ */ new WeakMap(), fa = /* @__PURE__ */ new WeakMap(), pa = {}, ma = 0, ha = function(e) {
	return e && (e.host || ha(e.parentNode));
}, ga = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = ha(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, _a = function(e, t, n, r) {
	var i = ga(t, Array.isArray(e) ? e : [e]);
	pa[n] || (pa[n] = /* @__PURE__ */ new WeakMap());
	var a = pa[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		e && !s.has(e) && (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		e && !c.has(e) && Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (da.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				da.set(e, c), a.set(e, l), o.push(e), c === 1 && i && fa.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), ma++, function() {
		o.forEach(function(e) {
			var t = da.get(e) - 1, i = a.get(e) - 1;
			da.set(e, t), a.set(e, i), t || (fa.has(e) || e.removeAttribute(r), fa.delete(e)), i || e.removeAttribute(n);
		}), ma--, ma || (da = /* @__PURE__ */ new WeakMap(), da = /* @__PURE__ */ new WeakMap(), fa = /* @__PURE__ */ new WeakMap(), pa = {});
	};
}, va = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || ua(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), _a(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, Q = function() {
	return Q = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, Q.apply(this, arguments);
};
function ya(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function ba(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
// ../../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var xa = "right-scroll-bar-position", Sa = "width-before-scroll-bar", Ca = "with-scroll-bars-hidden", wa = "--removed-body-scroll-bar-size";
// ../../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function Ta(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
// ../../../node_modules/use-callback-ref/dist/es2015/useRef.js
function Ea(e, t) {
	var n = w(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
// ../../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var Da = typeof window < "u" ? m.useLayoutEffect : m.useEffect, Oa = /* @__PURE__ */ new WeakMap();
function ka(e, t) {
	var n = Ea(t || null, function(t) {
		return e.forEach(function(e) {
			return Ta(e, t);
		});
	});
	return Da(function() {
		var t = Oa.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || Ta(e, null);
			}), i.forEach(function(e) {
				r.has(e) || Ta(e, a);
			});
		}
		Oa.set(n, e);
	}, [e]), n;
}
// ../../../node_modules/use-sidecar/dist/es2015/medium.js
function Aa(e) {
	return e;
}
function ja(e, t) {
	t === void 0 && (t = Aa);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function Ma(e) {
	e === void 0 && (e = {});
	var t = ja(null);
	return t.options = Q({
		async: !0,
		ssr: !1
	}, e), t;
}
// ../../../node_modules/use-sidecar/dist/es2015/exports.js
var Na = function(e) {
	var t = e.sideCar, n = ya(e, ["sideCar"]);
	if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var r = t.read();
	if (!r) throw Error("Sidecar medium not found");
	return m.createElement(r, Q({}, n));
};
Na.isSideCarExport = !0;
function Pa(e, t) {
	return e.useMedium(t), Na;
}
// ../../../node_modules/react-remove-scroll/dist/es2015/medium.js
var Fa = Ma(), Ia = function() {}, La = m.forwardRef(function(e, t) {
	var n = m.useRef(null), r = m.useState({
		onScrollCapture: Ia,
		onWheelCapture: Ia,
		onTouchMoveCapture: Ia
	}), i = r[0], a = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noRelative, h = e.noIsolation, g = e.inert, _ = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, b = e.gapMode, x = ya(e, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), S = f, C = ka([n, t]), w = Q(Q({}, x), i);
	return m.createElement(m.Fragment, null, u && m.createElement(S, {
		sideCar: Fa,
		removeScrollBar: l,
		shards: d,
		noRelative: p,
		noIsolation: h,
		inert: g,
		setCallbacks: a,
		allowPinchZoom: !!_,
		lockRef: n,
		gapMode: b
	}), o ? m.cloneElement(m.Children.only(s), Q(Q({}, w), { ref: C })) : m.createElement(y, Q({}, w, {
		className: c,
		ref: C
	}), s));
});
La.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, La.classNames = {
	fullWidth: Sa,
	zeroRight: xa
};
// ../../../node_modules/get-nonce/dist/es2015/index.js
var Ra = function() {
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
// ../../../node_modules/react-style-singleton/dist/es2015/singleton.js
function za() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = Ra();
	return t && e.setAttribute("nonce", t), e;
}
function Ba(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Va(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var Ha = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = za()) && (Ba(t, n), Va(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, Ua = function() {
	var e = Ha();
	return function(t, n) {
		m.useEffect(function() {
			return e.add(t), function() {
				e.remove();
			};
		}, [t && n]);
	};
}, Wa = function() {
	var e = Ua();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, Ga = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, Ka = function(e) {
	return parseInt(e || "", 10) || 0;
}, qa = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		Ka(n),
		Ka(r),
		Ka(i)
	];
}, Ja = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return Ga;
	var t = qa(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, Ya = Wa(), Xa = "data-scroll-locked", Za = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${Ca} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${Xa}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${xa} {
    right: ${s}px ${r};
  }
  
  .${Sa} {
    margin-right: ${s}px ${r};
  }
  
  .${xa} .${xa} {
    right: 0 ${r};
  }
  
  .${Sa} .${Sa} {
    margin-right: 0 ${r};
  }
  
  body[${Xa}] {
    ${wa}: ${s}px;
  }
`;
}, Qa = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, $a = function() {
	m.useEffect(function() {
		return document.body.setAttribute(Xa, (Qa() + 1).toString()), function() {
			var e = Qa() - 1;
			e <= 0 ? document.body.removeAttribute(Xa) : document.body.setAttribute(Xa, e.toString());
		};
	}, []);
}, eo = function(e) {
	var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
	$a();
	var a = m.useMemo(function() {
		return Ja(i);
	}, [i]);
	return m.createElement(Ya, { styles: Za(a, !t, i, n ? "" : "!important") });
}, to = !1;
if (typeof window < "u") try {
	var no = Object.defineProperty({}, "passive", { get: function() {
		return to = !0, !0;
	} });
	window.addEventListener("test", no, no), window.removeEventListener("test", no, no);
} catch {
	to = !1;
}
var ro = to ? { passive: !1 } : !1, io = function(e) {
	return e.tagName === "TEXTAREA";
}, ao = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !io(e) && n[t] === "visible");
}, oo = function(e) {
	return ao(e, "overflowY");
}, so = function(e) {
	return ao(e, "overflowX");
}, co = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), fo(e, r)) {
			var i = po(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, lo = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, uo = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, fo = function(e, t) {
	return e === "v" ? oo(t) : so(t);
}, po = function(e, t) {
	return e === "v" ? lo(t) : uo(t);
}, mo = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, ho = function(e, t, n, r, i) {
	var a = mo(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = po(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && fo(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, go = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, _o = function(e) {
	return [e.deltaX, e.deltaY];
}, vo = function(e) {
	return e && "current" in e ? e.current : e;
}, yo = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, bo = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, xo = 0, So = [];
function Co(e) {
	var t = m.useRef([]), n = m.useRef([0, 0]), r = m.useRef(), i = m.useState(xo++)[0], a = m.useState(Wa)[0], o = m.useRef(e);
	m.useEffect(function() {
		o.current = e;
	}, [e]), m.useEffect(function() {
		if (e.inert) {
			document.body.classList.add(`block-interactivity-${i}`);
			var t = ba([e.lockRef.current], (e.shards || []).map(vo), !0).filter(Boolean);
			return t.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${i}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${i}`), t.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${i}`);
				});
			};
		}
	}, [
		e.inert,
		e.lockRef.current,
		e.shards
	]);
	var s = m.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !o.current.allowPinchZoom;
		var i = go(e), a = n.current, s = "deltaX" in e ? e.deltaX : a[0] - i[0], c = "deltaY" in e ? e.deltaY : a[1] - i[1], l, u = e.target, d = Math.abs(s) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = co(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = co(d, u)), !m) return !1;
		if (!r.current && "changedTouches" in e && (s || c) && (r.current = l), !l) return !0;
		var h = r.current || l;
		return ho(h, t, e, h === "h" ? s : c, !0);
	}, []), c = m.useCallback(function(e) {
		var n = e;
		if (So.length && So[So.length - 1] === a) {
			var r = "deltaY" in n ? _o(n) : go(n), i = t.current.filter(function(e) {
				return e.name === n.type && (e.target === n.target || n.target === e.shadowParent) && yo(e.delta, r);
			})[0];
			if (i && i.should) n.cancelable && n.preventDefault();
			else if (!i) {
				var c = (o.current.shards || []).map(vo).filter(Boolean).filter(function(e) {
					return e.contains(n.target);
				});
				(c.length > 0 ? s(n, c[0]) : !o.current.noIsolation) && n.cancelable && n.preventDefault();
			}
		}
	}, []), l = m.useCallback(function(e, n, r, i) {
		var a = {
			name: e,
			delta: n,
			target: r,
			should: i,
			shadowParent: wo(r)
		};
		t.current.push(a), setTimeout(function() {
			t.current = t.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), u = m.useCallback(function(e) {
		n.current = go(e), r.current = void 0;
	}, []), d = m.useCallback(function(t) {
		l(t.type, _o(t), t.target, s(t, e.lockRef.current));
	}, []), f = m.useCallback(function(t) {
		l(t.type, go(t), t.target, s(t, e.lockRef.current));
	}, []);
	m.useEffect(function() {
		return So.push(a), e.setCallbacks({
			onScrollCapture: d,
			onWheelCapture: d,
			onTouchMoveCapture: f
		}), document.addEventListener("wheel", c, ro), document.addEventListener("touchmove", c, ro), document.addEventListener("touchstart", u, ro), function() {
			So = So.filter(function(e) {
				return e !== a;
			}), document.removeEventListener("wheel", c, ro), document.removeEventListener("touchmove", c, ro), document.removeEventListener("touchstart", u, ro);
		};
	}, []);
	var p = e.removeScrollBar, h = e.inert;
	return m.createElement(m.Fragment, null, h ? m.createElement(a, { styles: bo(i) }) : null, p ? m.createElement(eo, {
		noRelative: e.noRelative,
		gapMode: e.gapMode
	}) : null);
}
function wo(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
// ../../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var To = Pa(Fa, Co), Eo = m.forwardRef(function(e, t) {
	return m.createElement(La, Q({}, e, {
		ref: t,
		sideCar: To
	}));
});
Eo.classNames = La.classNames;
// ../../../node_modules/@radix-ui/react-popover/dist/index.mjs
var Do = Object.defineProperty, Oo = (e, t) => Do(e, "name", {
	value: t,
	configurable: !0
}), ko = "Popover", [Ao, jo] = /* @__PURE__ */ at(ko, [wi]), Mo = wi(), [No, Po] = Ao(ko), Fo = /* @__PURE__ */ Oo((e) => {
	let { __scopePopover: t, children: n, open: r, defaultOpen: i, onOpenChange: a, modal: o = !1 } = e, s = Mo(t), c = m.useRef(null), [l, u] = m.useState(!1), [d, f] = aa({
		prop: r,
		defaultProp: i ?? !1,
		onChange: a,
		caller: ko
	});
	return /* @__PURE__ */ E(Li, {
		...s,
		children: /* @__PURE__ */ E(No, {
			scope: t,
			contentId: mn(),
			triggerRef: c,
			open: d,
			onOpenChange: f,
			onOpenToggle: m.useCallback(() => f((e) => !e), [f]),
			hasCustomAnchor: l,
			onCustomAnchorAdd: m.useCallback(() => u(!0), []),
			onCustomAnchorRemove: m.useCallback(() => u(!1), []),
			modal: o,
			children: n
		})
	});
}, "Popover"), Io = "PopoverTrigger", Lo = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Oo(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = Po(Io, n), a = Mo(n), o = nt(t, i.triggerRef), s = /* @__PURE__ */ E(Ct.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": Jo(i.open),
		...r,
		ref: o,
		onClick: qe(e.onClick, i.onOpenToggle)
	});
	return i.hasCustomAnchor ? s : /* @__PURE__ */ E(Ri, {
		asChild: !0,
		...a,
		children: s
	});
}, "PopoverTrigger")), Ro = "PopoverPortal", [zo, Bo] = Ao(Ro, { forceMount: void 0 }), Vo = /* @__PURE__ */ Oo((e) => {
	let { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = Po(Ro, t);
	return /* @__PURE__ */ E(zo, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ E(Gi, {
			present: n || a.open,
			children: /* @__PURE__ */ E(Vi, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "PopoverPortal"), Ho = "PopoverContent", Uo = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Oo(function(e, t) {
	let n = Bo(Ho, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = Po(Ho, e.__scopePopover);
	return /* @__PURE__ */ E(Gi, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ E(Go, {
			...i,
			ref: t
		}) : /* @__PURE__ */ E(Ko, {
			...i,
			ref: t
		})
	});
}, "PopoverContent")), Wo = /* @__PURE__ */ ct("PopoverContent.RemoveScroll"), Go = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Oo(function(e, t) {
	let n = Po(Ho, e.__scopePopover), r = m.useRef(null), i = nt(t, r), a = m.useRef(!1);
	return m.useEffect(() => {
		let e = r.current;
		if (e) return va(e);
	}, []), /* @__PURE__ */ E(Eo, {
		as: Wo,
		allowPinchZoom: !0,
		children: /* @__PURE__ */ E(qo, {
			...e,
			ref: i,
			trapFocus: n.open,
			disableOutsidePointerEvents: !0,
			onCloseAutoFocus: qe(e.onCloseAutoFocus, (e) => {
				e.preventDefault(), a.current || n.triggerRef.current?.focus();
			}),
			onPointerDownOutside: qe(e.onPointerDownOutside, (e) => {
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
				a.current = r;
			}, { checkForDefaultPrevented: !1 }),
			onFocusOutside: qe(e.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 })
		})
	});
}, "PopoverContentModal")), Ko = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Oo(function(e, t) {
	let n = Po(Ho, e.__scopePopover), r = m.useRef(!1), i = m.useRef(!1);
	return /* @__PURE__ */ E(qo, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
		},
		onInteractOutside: (t) => {
			e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
			let a = t.target;
			n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
		}
	});
}, "PopoverContentNonModal")), qo = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Oo(function(e, t) {
	let { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...d } = e, f = Po(Ho, n), p = Mo(n);
	return Kt(), /* @__PURE__ */ E(Qt, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ E(Pt, {
			asChild: !0,
			disableOutsidePointerEvents: o,
			onInteractOutside: u,
			onEscapeKeyDown: s,
			onPointerDownOutside: c,
			onFocusOutside: l,
			onDismiss: () => f.onOpenChange(!1),
			deferPointerDownOutside: !0,
			children: /* @__PURE__ */ E(zi, {
				"data-state": Jo(f.open),
				role: "dialog",
				id: f.contentId,
				...p,
				...d,
				ref: t,
				style: {
					...d.style,
					"--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
					"--radix-popover-content-available-width": "var(--radix-popper-available-width)",
					"--radix-popover-content-available-height": "var(--radix-popper-available-height)",
					"--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
					"--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
				}
			})
		})
	});
}, "PopoverContentImpl"));
function Jo(e) {
	return e ? "open" : "closed";
}
Oo(Jo, "getState");
var Yo = Fo, Xo = Lo, Zo = Vo, Qo = Uo, $o = {
	tooltip: "_tooltip_5svgn_1",
	popover: "_popover_5svgn_5"
}, es = ({ actions: e, buttonProps: { onClick: t, ...n } = {}, side: r = "bottom", align: a = "end" }) => {
	let [o, c] = w(!1), u = y((e) => {
		e.stopPropagation(), t?.(e);
	}, [t]);
	if (!e.length) return null;
	let d = (e, t) => {
		switch (e.type) {
			case "button":
			case "link": {
				let n = /* @__PURE__ */ E(i.Item, {
					icon: e.icon,
					onClick: (t) => {
						e.onClick?.(t), c(!1);
					},
					isDisabled: e.disabled ?? !1,
					children: /* @__PURE__ */ D(s, {
						as: "span",
						flexDirection: "column",
						alignItems: "flex-start",
						gap: "2px",
						children: [/* @__PURE__ */ E("span", { children: e.label }), e.description && /* @__PURE__ */ E(f.Paragraph, {
							as: "span",
							variant: "4",
							subdued: !0,
							children: e.description
						})]
					})
				});
				return /* @__PURE__ */ E(p, {
					className: $o.tooltip,
					content: e.tooltip,
					children: e.type === "link" ? g(e.link, { children: n }) : n
				}, t);
			}
			case "divider": return /* @__PURE__ */ E(i.Divider, {}, t);
			default: return null;
		}
	};
	return /* @__PURE__ */ D(Yo, {
		open: o,
		onOpenChange: c,
		children: [/* @__PURE__ */ E(Xo, {
			asChild: !0,
			children: /* @__PURE__ */ E(l, {
				variant: "tertiary",
				icon: "dots-v",
				onClick: u,
				...n
			})
		}), /* @__PURE__ */ E(Zo, { children: /* @__PURE__ */ E(Qo, {
			className: $o.popover,
			side: r,
			align: a,
			sideOffset: 8,
			onOpenAutoFocus: (e) => e.preventDefault(),
			children: /* @__PURE__ */ E(i, { children: e.map((e, t) => d(e, t)) })
		}) })]
	});
}, ts = /* @__PURE__ */ ze(((e, t) => {
	t.exports = Object.prototype.hasOwnProperty.call(m, "module.exports") ? m["module.exports"] : { ...m };
})), ns = /* @__PURE__ */ Be({ CountUp: () => is }), rs, is, as = Re((() => {
	rs = function() {
		return (rs = Object.assign || function(e) {
			for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
			return e;
		}).apply(this, arguments);
	}, is = function() {
		function e(e, t, n) {
			var r = this;
			this.endVal = t, this.options = n, this.version = "2.6.0", this.defaults = {
				startVal: 0,
				decimalPlaces: 0,
				duration: 2,
				useEasing: !0,
				useGrouping: !0,
				useIndianSeparators: !1,
				smartEasingThreshold: 999,
				smartEasingAmount: 333,
				separator: ",",
				decimal: ".",
				prefix: "",
				suffix: "",
				enableScrollSpy: !1,
				scrollSpyDelay: 200,
				scrollSpyOnce: !1
			}, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(e) {
				r.startTime ||= e;
				var t = e - r.startTime;
				r.remaining = r.duration - t, r.frameVal = r.useEasing ? r.countDown ? r.startVal - r.easingFn(t, 0, r.startVal - r.endVal, r.duration) : r.easingFn(t, r.startVal, r.endVal - r.startVal, r.duration) : r.startVal + (r.endVal - r.startVal) * (t / r.duration), r.frameVal = (r.countDown ? r.frameVal < r.endVal : r.frameVal > r.endVal) ? r.endVal : r.frameVal, r.frameVal = Number(r.frameVal.toFixed(r.options.decimalPlaces)), r.printValue(r.frameVal), t < r.duration ? r.rAF = requestAnimationFrame(r.count) : r.finalEndVal === null ? r.options.onCompleteCallback && r.options.onCompleteCallback() : r.update(r.finalEndVal);
			}, this.formatNumber = function(e) {
				var t, n, i, a, o = e < 0 ? "-" : "";
				t = Math.abs(e).toFixed(r.options.decimalPlaces);
				var s = (t += "").split(".");
				if (n = s[0], i = s.length > 1 ? r.options.decimal + s[1] : "", r.options.useGrouping) {
					a = "";
					for (var c = 3, l = 0, u = 0, d = n.length; u < d; ++u) r.options.useIndianSeparators && u === 4 && (c = 2, l = 1), u !== 0 && l % c == 0 && (a = r.options.separator + a), l++, a = n[d - u - 1] + a;
					n = a;
				}
				return r.options.numerals && r.options.numerals.length && (n = n.replace(/[0-9]/g, function(e) {
					return r.options.numerals[+e];
				}), i = i.replace(/[0-9]/g, function(e) {
					return r.options.numerals[+e];
				})), o + r.options.prefix + n + i + r.options.suffix;
			}, this.easeOutExpo = function(e, t, n, r) {
				return n * (1 - 2 ** (-10 * e / r)) * 1024 / 1023 + t;
			}, this.options = rs(rs({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(t), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof e == "string" ? document.getElementById(e) : e, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, e) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
				return r.handleScroll(r);
			}), window.onscroll = function() {
				window.onScrollFns.forEach(function(e) {
					return e();
				});
			}, this.handleScroll(this)));
		}
		return e.prototype.handleScroll = function(e) {
			if (e && window && !e.once) {
				var t = window.innerHeight + window.scrollY, n = e.el.getBoundingClientRect(), r = n.top + window.pageYOffset, i = n.top + n.height + window.pageYOffset;
				i < t && i > window.scrollY && e.paused ? (e.paused = !1, setTimeout(function() {
					return e.start();
				}, e.options.scrollSpyDelay), e.options.scrollSpyOnce && (e.once = !0)) : (window.scrollY > i || r > t) && !e.paused && e.reset();
			}
		}, e.prototype.determineDirectionAndSmartEasing = function() {
			var e = this.finalEndVal ? this.finalEndVal : this.endVal;
			this.countDown = this.startVal > e;
			var t = e - this.startVal;
			if (Math.abs(t) > this.options.smartEasingThreshold && this.options.useEasing) {
				this.finalEndVal = e;
				var n = this.countDown ? 1 : -1;
				this.endVal = e + n * this.options.smartEasingAmount, this.duration /= 2;
			} else this.endVal = e, this.finalEndVal = null;
			this.useEasing = this.finalEndVal === null && this.options.useEasing;
		}, e.prototype.start = function(e) {
			this.error || (e && (this.options.onCompleteCallback = e), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
		}, e.prototype.pauseResume = function() {
			this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
		}, e.prototype.reset = function() {
			cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
		}, e.prototype.update = function(e) {
			cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(e), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal ?? this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
		}, e.prototype.printValue = function(e) {
			var t;
			if (this.el) {
				var n = this.formattingFn(e);
				(t = this.options.plugin) != null && t.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
			}
		}, e.prototype.ensureNumber = function(e) {
			return typeof e == "number" && !isNaN(e);
		}, e.prototype.validateValue = function(e) {
			var t = Number(e);
			return this.ensureNumber(t) ? t : (this.error = `[CountUp] invalid start or end value: ${e}`, null);
		}, e.prototype.resetDuration = function() {
			this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
		}, e;
	}();
})), os = /* @__PURE__ */ He((/* @__PURE__ */ ze(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = ts(), n = (as(), Ue(ns));
	function r(e, t) {
		var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (n != null) {
			var r, i, a, o, s = [], c = !0, l = !1;
			try {
				if (a = (n = n.call(e)).next, t === 0) {
					if (Object(n) !== n) return;
					c = !1;
				} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
			} catch (e) {
				l = !0, i = e;
			} finally {
				try {
					if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
				} finally {
					if (l) throw i;
				}
			}
			return s;
		}
	}
	function i(e, t) {
		var n = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var r = Object.getOwnPropertySymbols(e);
			t && (r = r.filter(function(t) {
				return Object.getOwnPropertyDescriptor(e, t).enumerable;
			})), n.push.apply(n, r);
		}
		return n;
	}
	function a(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t] == null ? {} : arguments[t];
			t % 2 ? i(Object(n), !0).forEach(function(t) {
				o(e, t, n[t]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
				Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
			});
		}
		return e;
	}
	function o(e, t, n) {
		return t = g(t), t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function s() {
		return s = Object.assign ? Object.assign.bind() : function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, s.apply(this, arguments);
	}
	function c(e, t) {
		if (e == null) return {};
		for (var n = {}, r = Object.keys(e), i, a = 0; a < r.length; a++) i = r[a], t.indexOf(i) >= 0 || (n[i] = e[i]);
		return n;
	}
	function l(e, t) {
		if (e == null) return {};
		var n = c(e, t), r, i;
		if (Object.getOwnPropertySymbols) {
			var a = Object.getOwnPropertySymbols(e);
			for (i = 0; i < a.length; i++) r = a[i], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
		}
		return n;
	}
	function u(e, t) {
		return d(e) || r(e, t) || f(e, t) || m();
	}
	function d(e) {
		if (Array.isArray(e)) return e;
	}
	function f(e, t) {
		if (e) {
			if (typeof e == "string") return p(e, t);
			var n = Object.prototype.toString.call(e).slice(8, -1);
			if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
			if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return p(e, t);
		}
	}
	function p(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	function m() {
		throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function h(e, t) {
		if (typeof e != "object" || !e) return e;
		var n = e[Symbol.toPrimitive];
		if (n !== void 0) {
			var r = n.call(e, t || "default");
			if (typeof r != "object") return r;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (t === "string" ? String : Number)(e);
	}
	function g(e) {
		var t = h(e, "string");
		return typeof t == "symbol" ? t : String(t);
	}
	var _ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? t.useLayoutEffect : t.useEffect;
	function v(e) {
		var n = t.useRef(e);
		return _(function() {
			n.current = e;
		}), t.useCallback(function() {
			var e = [...arguments];
			return n.current.apply(void 0, e);
		}, []);
	}
	var y = function(e, t) {
		var r = t.decimal, i = t.decimals, a = t.duration, o = t.easingFn, s = t.end, c = t.formattingFn, l = t.numerals, u = t.prefix, d = t.separator, f = t.start, p = t.suffix, m = t.useEasing, h = t.useGrouping, g = t.useIndianSeparators, _ = t.enableScrollSpy, v = t.scrollSpyDelay, y = t.scrollSpyOnce;
		return new n.CountUp(e, s, {
			startVal: f,
			duration: a,
			decimal: r,
			decimalPlaces: i,
			easingFn: o,
			formattingFn: c,
			numerals: l,
			separator: d,
			prefix: u,
			suffix: p,
			useEasing: m,
			useIndianSeparators: g,
			useGrouping: h,
			enableScrollSpy: _,
			scrollSpyDelay: v,
			scrollSpyOnce: y
		});
	}, b = [
		"ref",
		"startOnMount",
		"enableReinitialize",
		"delay",
		"onEnd",
		"onStart",
		"onPauseResume",
		"onReset",
		"onUpdate"
	], x = {
		decimal: ".",
		separator: ",",
		delay: null,
		prefix: "",
		suffix: "",
		duration: 2,
		start: 0,
		decimals: 0,
		startOnMount: !0,
		enableReinitialize: !0,
		useEasing: !0,
		useGrouping: !0,
		useIndianSeparators: !1
	}, S = function(e) {
		var n = Object.fromEntries(Object.entries(e).filter(function(e) {
			return u(e, 2)[1] !== void 0;
		})), r = t.useMemo(function() {
			return a(a({}, x), n);
		}, [e]), i = r.ref, o = r.startOnMount, s = r.enableReinitialize, c = r.delay, d = r.onEnd, f = r.onStart, p = r.onPauseResume, m = r.onReset, h = r.onUpdate, g = l(r, b), _ = t.useRef(), S = t.useRef(), C = t.useRef(!1), w = v(function() {
			return y(typeof i == "string" ? i : i.current, g);
		}), T = v(function(e) {
			var t = _.current;
			if (t && !e) return t;
			var n = w();
			return _.current = n, n;
		}), E = v(function() {
			var e = function() {
				return T(!0).start(function() {
					d?.({
						pauseResume: D,
						reset: O,
						start: A,
						update: k
					});
				});
			};
			c && c > 0 ? S.current = setTimeout(e, c * 1e3) : e(), f?.({
				pauseResume: D,
				reset: O,
				update: k
			});
		}), D = v(function() {
			T().pauseResume(), p?.({
				reset: O,
				start: A,
				update: k
			});
		}), O = v(function() {
			T().el && (S.current && clearTimeout(S.current), T().reset(), m?.({
				pauseResume: D,
				start: A,
				update: k
			}));
		}), k = v(function(e) {
			T().update(e), h?.({
				pauseResume: D,
				reset: O,
				start: A
			});
		}), A = v(function() {
			O(), E();
		}), j = v(function(e) {
			o && (e && O(), E());
		});
		return t.useEffect(function() {
			C.current ? s && j(!0) : (C.current = !0, j());
		}, [
			s,
			C,
			j,
			c,
			e.start,
			e.suffix,
			e.prefix,
			e.duration,
			e.separator,
			e.decimals,
			e.decimal,
			e.formattingFn
		]), t.useEffect(function() {
			return function() {
				O();
			};
		}, [O]), {
			start: A,
			pauseResume: D,
			reset: O,
			update: k,
			getCountUp: T
		};
	}, C = [
		"className",
		"redraw",
		"containerProps",
		"children",
		"style"
	];
	e.default = function(e) {
		var n = e.className, r = e.redraw, i = e.containerProps, o = e.children, c = e.style, u = l(e, C), d = t.useRef(null), f = t.useRef(!1), p = S(a(a({}, u), {}, {
			ref: d,
			startOnMount: typeof o != "function" || e.delay === 0,
			enableReinitialize: !1
		})), m = p.start, h = p.reset, g = p.update, _ = p.pauseResume, y = p.getCountUp, b = v(function() {
			m();
		}), x = v(function(t) {
			e.preserveValue || h(), g(t);
		}), w = v(function() {
			typeof e.children == "function" && !(d.current instanceof Element) ? console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.") : y();
		});
		t.useEffect(function() {
			w();
		}, [w]), t.useEffect(function() {
			f.current && x(e.end);
		}, [e.end, x]);
		var T = r && e;
		return t.useEffect(function() {
			r && f.current && b();
		}, [
			b,
			r,
			T
		]), t.useEffect(function() {
			!r && f.current && b();
		}, [
			b,
			r,
			e.start,
			e.suffix,
			e.prefix,
			e.duration,
			e.separator,
			e.decimals,
			e.decimal,
			e.className,
			e.formattingFn
		]), t.useEffect(function() {
			f.current = !0;
		}, []), typeof o == "function" ? o({
			countUpRef: d,
			start: m,
			reset: h,
			update: g,
			pauseResume: _,
			getCountUp: y
		}) : /*#__PURE__*/ t.createElement("span", s({
			className: n,
			ref: d,
			style: c
		}, i), e.start === void 0 ? "" : y().formattingFn(e.start));
	}, e.useCountUp = S;
})))()), ss = {
	bar: "_bar_1n5dj_1",
	section: "_section_1n5dj_5",
	sectionHidden: "_sectionHidden_1n5dj_8",
	sectionInheritRadius: "_sectionInheritRadius_1n5dj_11",
	valueOutside: "_valueOutside_1n5dj_15"
}, cs = ({ value: e, label: n, labelWidth: r, theme: i = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"], showFullBar: a = !1, showDifference: o = !1 }) => {
	let c = Math.min(e, 100), [l, u] = w([null, null]), d = N(l);
	b(() => {
		u([c, ...a ? [100 - c] : []]);
	}, [c, a]);
	let p = 1.5, m = S(() => l.map((e, t) => {
		let n = c && t === 0 || o, r = e !== null && e < 20, l = k(ss.section, {
			[ss.sectionHidden]: a && e === 0,
			[ss.sectionInheritRadius]: !a
		}), u = k(ss.section, { [ss.valueOutside]: r });
		return /* @__PURE__ */ E(s, {
			justifyContent: "flex-end",
			alignItems: "center",
			padding: "0 100",
			background: i[t],
			color: "neutral.000",
			className: l,
			style: {
				flexBasis: `${e ?? 0}%`,
				transition: `flex-basis ${p}s ease-out`
			},
			children: n && /* @__PURE__ */ E(f.Paragraph, {
				className: u,
				variant: "4",
				color: t === 0 && !r ? "var(--dixa-color-neutral-000)" : "var(--dixa-color-neutral-900)",
				children: /* @__PURE__ */ E(os.default, {
					start: d?.[t] ?? 0,
					end: e ?? 0,
					duration: p,
					delay: 0,
					suffix: "%",
					children: ({ countUpRef: e }) => /* @__PURE__ */ E("span", { ref: e })
				})
			})
		}, t);
	}), [
		c,
		i,
		o,
		a,
		l,
		d
	]);
	return /* @__PURE__ */ D(s, {
		alignItems: "center",
		gap: "200",
		children: [n && /* @__PURE__ */ E(t, {
			minWidth: r ? `${r}px` : "auto",
			children: /* @__PURE__ */ E(f.Paragraph, {
				variant: "4",
				children: n
			})
		}), /* @__PURE__ */ E(s, {
			flex: "1",
			className: ss.bar,
			height: "20px",
			borderRadius: "50",
			children: m
		})]
	});
};
// src/utils/formatting/dateTime/dateTime.ts
function ls(e, t = { compact: !1 }) {
	if (e < 1e3) return `${(e / 1e3).toFixed(0)}s`;
	let n = Math.floor(e / 1e3 % 60), r = Math.floor(e / 6e4 % 60), i = Math.floor(e / 36e5 % 24), a = Math.floor(e / 864e5), o = (e, t) => e > 0 ? `${e}${t}` : "";
	return [
		o(a, "d"),
		o(i, "h"),
		o(r, "m") || (t.compact ? "" : "0m"),
		o(n, "s") || (t.compact ? "" : "0s")
	].filter(Boolean).join(" ");
}
function us(e) {
	return /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/.test(e) ? ve(e, ve.ISO_8601, !0).isValid() : !1;
}
// src/utils/formatting/number/number.ts
var ds = 1e6, fs = 1e3;
function ps(e) {
	if (e < fs) return ms(e);
	let t = e >= ds, n = parseFloat((e / (t ? ds : fs)).toFixed(1)), r = t ? "M" : "K";
	return `${ms(n)}${r}`;
}
function ms(e) {
	return e.toLocaleString(navigator.language);
}
// src/utils/instruments/categorizeInstruments/categorizeInstruments.ts
var hs = (e) => ({
	metrics: e.filter(gs),
	chart: e.find(_s),
	heatmap: e.find(vs),
	table: e.find(ys),
	presence: e.find(bs),
	insight: e.find(xs)
}), gs = (e) => e.type === "metric", _s = (e) => e.type === "chart" && e.visualization !== "heatmap", vs = (e) => e.type === "chart" && e.visualization === "heatmap", ys = (e) => e.type === "table", bs = (e) => e.type === "presence", xs = (e) => e.type === "ai_insight", Ss = (e, t) => {
	switch (t) {
		case "duration": return ls(e).split(" ").slice(0, 2).join(" ");
		case "count": return ps(e);
		case "number": return ms(e);
		case "percentage": return `${ms(e)}%`;
		case "timer": return ls(e);
		default: return "";
	}
}, Cs = {
	default: 8,
	rating: 5
}, ws = ye.purple[700], Ts = (e) => /^#|^rgb(a)?\(|^hsl(a)?\(|^var\(/.test(e), Es = (e) => {
	let [t, n] = e.split("-"), r = Number(n);
	return Cs[t] ? r >= 1 && r <= Cs[t] : !1;
}, Ds = (e) => Ts(e) ? e : Es(e) ? `var(--dixa-analytics-color-${e}, ${ws})` : ws, Os = (e, t = "default", n) => n ? Ds(n) : `var(--dixa-analytics-color-${t}-${e % (Cs[t] ?? Cs.default) + 1}, ${ws})`, ks = { container: "_container_1t2a7_1" }, $ = {
	tickCount: 5,
	tickProps: {
		fontFamily: "var(--dixa-typography-family-default)",
		fontSize: "var(--dixa-typography-size-200)",
		fill: "var(--dixa-typography-color-tertiary)"
	},
	visualizationIcons: {
		bar: "chart-bar",
		line: "chart-line",
		area: "chart-area",
		pie: "chart-pie",
		donut: "chart-donut"
	},
	instrumentFormatAssets: {
		count: {
			label: "#",
			description: "Absolute short numbers, e.g. 1.2K"
		},
		number: {
			label: "#",
			description: "Absolute numbers, e.g. 1.234"
		},
		percentage: {
			label: "%",
			description: "Relative percentages, e.g. 12.34%"
		},
		duration: {
			label: "s",
			description: "Durations, e.g. 12m 34s"
		}
	}
}, As = v(function({ formats: e, onChangeFormat: t }) {
	return /* @__PURE__ */ E(r, {
		variant: "secondary",
		children: e.map(({ value: e, selected: r }) => /* @__PURE__ */ E(n, {
			onClick: r ? void 0 : () => t?.(e),
			active: r,
			title: $.instrumentFormatAssets[e]?.description,
			children: $.instrumentFormatAssets[e]?.label
		}, e))
	});
}), js = v(function({ granularities: e, onChangeGranularity: t }) {
	return /* @__PURE__ */ E(r, {
		variant: "secondary",
		children: e.map(({ value: e, selected: r }) => /* @__PURE__ */ E(n, {
			onClick: r ? void 0 : () => t?.(e),
			active: r,
			children: e
		}, e))
	});
}), Ms = {
	root: "_root_6kwn9_1",
	rootBounded: "_rootBounded_6kwn9_7",
	rootFluid: "_rootFluid_6kwn9_7"
}, Ns = ({ bounded: e = !1, fluid: t = !1, children: n }) => {
	let r = k(Ms.root, {
		[Ms.rootBounded]: e,
		[Ms.rootFluid]: t
	});
	return /* @__PURE__ */ E("div", {
		className: r,
		children: n
	});
}, Ps = v(function({ data: e }) {
	let [t, n] = w(0);
	return b(() => {
		n(Math.max(0, Date.now() - e));
	}, [e]), A(() => {
		n(Math.max(0, Date.now() - e));
	}, 1e3), /* @__PURE__ */ E(T, { children: Ss(t, "timer") });
}), Fs = {
	wrapper: "_wrapper_1w7q6_1",
	text: "_text_1w7q6_6"
}, Is = v(function({ className: e, data: t, format: n, color: r, suffix: i }) {
	let a = S(() => {
		if (t === null) return "n.a.";
		switch (n) {
			case "timer": return /* @__PURE__ */ E(Ps, { data: t });
			default: return Ss(t, n);
		}
	}, [t, n]), o = S(() => {
		if (t !== null) switch (n) {
			case "duration": return ls(t);
			case "count": return ms(t);
			default: return;
		}
	}, [t, n]), s = t === null || o === a || [
		"number",
		"percentage",
		"timer"
	].includes(n);
	return /* @__PURE__ */ E(p, {
		content: o,
		disabled: s,
		wrap: "div",
		wrapProps: { className: Fs.wrapper },
		children: /* @__PURE__ */ D(f.Heading, {
			variant: "heading-1",
			color: r ?? (t === null ? "tertiary" : void 0),
			className: k(Fs.text, e),
			as: "span",
			children: [a, i]
		})
	});
}), Ls = { colorIndicator: "_colorIndicator_luubh_1" }, Rs = v(function({ instrument: e, theme: n = "light" }) {
	let { data: r, format: i, title: a, description: o, color: c } = e, l = c ? Ds(c) : void 0, u = n === "dark" ? "inherit" : void 0;
	return /* @__PURE__ */ D(s, {
		flexDirection: "column",
		gap: "100",
		children: [
			/* @__PURE__ */ D(s, {
				alignItems: "center",
				gap: "100",
				title: a,
				children: [c && /* @__PURE__ */ E(t, {
					as: "span",
					className: Ls.colorIndicator,
					background: l
				}), /* @__PURE__ */ E(f.Paragraph, {
					variant: "4",
					color: u,
					subdued: !0,
					children: a
				})]
			}),
			/* @__PURE__ */ E(Is, {
				data: r,
				format: i,
				color: u
			}),
			o && /* @__PURE__ */ E(f.Paragraph, {
				variant: "4",
				color: u,
				subdued: !0,
				children: o
			})
		]
	});
}), zs = ({ categories: e, series: t }, { omitZero: n }) => e.map((e, r) => {
	let i = t.reduce((e, { label: t, data: i }) => {
		let { value: a } = Bs(i[r]);
		return (n ? !a : a === null) ? e : {
			...e,
			[t]: a
		};
	}, {});
	return {
		name: e.label,
		...i
	};
}), Bs = (e) => e === null || typeof e == "number" ? { value: e } : {
	value: e?.value ?? null,
	metrics: e?.metrics
}, Vs = (e) => e?.find(({ selected: e }) => e)?.value ?? "number", Hs = xe, Us = (e, t = "D", { long: n = !1, timezone: r = ve.tz.guess() } = {}) => {
	let i = ve.tz(e, r), a = ve.locale() === "en", o = (e) => n ? e.format("ddd, ll") : e.format(a ? "MMM DD" : "DD MMM");
	switch (t) {
		case "H": return i.format("LT");
		case "W": return n ? `${o(i)} - ${o(i.endOf("week"))} (W${i.format("W")})` : o(i);
		case "M": return i.format(n ? "MMM YYYY" : "MMM");
		default: return o(i);
	}
}, Ws = (e, t = {}) => t?.length ? Hs(e, t) : e, Gs = { root: "_root_scczo_54" }, Ks = v(function({ instrument: e, granularity: t, timezone: n, tooltipProps: r }) {
	let { active: i, payload: a, label: o } = r, { categories: c, series: l } = e.data, u = c.find((e) => e.label === o), d = u?.metrics ?? [], p = Math.max(0, (a?.length ?? 0) - 24), m = Vs(e.data.formats), h = S(() => l.length !== 1 || !["count", "number"].includes(m) || c.every(({ label: e }) => us(e)) ? null : l[0].data.reduce((e, t) => {
		let { value: n } = Bs(t);
		return typeof n == "number" ? e + n : e;
	}, 0), [
		c,
		m,
		l
	]), g = S(() => a?.slice(0, p > 0 ? 23 : 24).map((e) => {
		let t = e.value ?? 0, n = t && h ? t / h * 100 : null, r = n ? `${n.toFixed(2)}%` : void 0;
		return {
			type: "metric",
			title: e.name ?? "",
			color: e.color,
			data: t,
			format: m,
			description: r
		};
	}), [
		a,
		24,
		p,
		h,
		m
	]), _ = y((e) => e?.map((e) => /* @__PURE__ */ E(Rs, {
		instrument: e,
		theme: "dark"
	}, e.title)), []), v = S(() => u?.label ? us(u.label) ? Us(u.label, t, {
		timezone: n,
		long: !0
	}) : Ws(u.label) : null, [
		u?.label,
		t,
		n
	]);
	return !i || !a ? null : /* @__PURE__ */ D("div", {
		className: Gs.root,
		children: [
			v && /* @__PURE__ */ D(s, {
				flexDirection: "column",
				gap: "100",
				children: [/* @__PURE__ */ E(f.Heading, {
					variant: "heading-2",
					color: "inherit",
					children: v
				}), u?.description && /* @__PURE__ */ E(f.Paragraph, {
					variant: "4",
					color: "inherit",
					children: u.description
				})]
			}),
			d.length > 0 && /* @__PURE__ */ E(Ns, {
				bounded: !0,
				children: _(d)
			}),
			/* @__PURE__ */ D(Ns, {
				bounded: !0,
				children: [_(g), p > 0 && /* @__PURE__ */ E(s, {
					flex: "1",
					alignItems: "center",
					children: /* @__PURE__ */ D(f.Heading, {
						variant: "heading-2",
						color: "inherit",
						children: [
							"+ ",
							p + 1,
							" more"
						]
					})
				})]
			})
		]
	});
}), qs = Se, Js = v(function({ visualization: e, visualizations: t, onChangeVisualization: n }) {
	return t.length <= 1 ? null : /* @__PURE__ */ E(r, {
		variant: "secondary",
		children: t.map((t) => /* @__PURE__ */ E(l, {
			icon: $.visualizationIcons[t],
			onClick: () => {
				n(t);
			},
			active: e === t,
			title: `${qs(t)} chart`
		}, t))
	});
}), Ys = ({ instrument: e, granularity: t, timezone: n, syncOptions: r }) => {
	let { data: i, layout: a } = e, o = a === "horizontal", s = a === "vertical", c = S(() => {
		if (s) return 0;
		let e = i.categories.length % 2 == 0;
		switch (t) {
			case "H": return "preserveStart";
			case "D":
			case "W": return e ? "preserveEnd" : "preserveStart";
			default: return "preserveStartEnd";
		}
	}, [
		i.categories.length,
		t,
		s
	]), l = {
		dataKey: "name",
		width: s ? 192 : 0,
		tickLine: { stroke: "var(--dixa-color-neutral-200)" },
		axisLine: { stroke: "var(--dixa-color-neutral-200)" },
		tickSize: 6,
		tickMargin: 8,
		interval: c,
		tick: $.tickProps,
		tickFormatter: (e) => us(e) ? Us(e, t, { timezone: n }) : Ws(e, { length: 192 / 10 })
	}, u = {
		domain: [0, "auto"],
		allowDecimals: !1,
		tickLine: !1,
		axisLine: !1,
		tick: $.tickProps,
		ticks: r?.ticks,
		tickCount: $.tickCount,
		tickFormatter: (e) => Ss(e, Vs(i.formats))
	};
	return {
		xAxisProps: o ? {
			type: "category",
			...l
		} : {
			type: "number",
			...u
		},
		yAxisProps: o ? {
			type: "number",
			...u
		} : {
			type: "category",
			...l
		}
	};
}, Xs = Ce, Zs = {
	legendItem: "_legendItem_15b15_54",
	legendItemInactive: "_legendItemInactive_15b15_61",
	legendIcon: "_legendIcon_15b15_65",
	legendIconBar: "_legendIconBar_15b15_72",
	legendIconLine: "_legendIconLine_15b15_75"
}, Qs = v(function({ instrument: e, legend: t, visualization: n, onToggleLegendItem: r, onMouseEnterLegendItem: i, onMouseLeaveLegendItem: a, hoveredLegend: o }) {
	let { series: c, options: l } = e.data, { layout: u } = l?.legend ?? { layout: "horizontal" }, d = u === "horizontal";
	return /* @__PURE__ */ E(s, {
		padding: d ? "0" : "0 0 0 400",
		flexDirection: d ? "row" : "column",
		gap: d ? "400" : "200",
		justifyContent: "center",
		children: c.map(({ label: e, options: c }, l) => {
			let u = Os(l, void 0, c?.color), d = k(Zs.legendItem, { [Zs.legendItemInactive]: o && o !== e }), p = k(Zs.legendIcon, {
				[Zs.legendIconBar]: n !== "line",
				[Zs.legendIconLine]: n === "line"
			});
			return /* @__PURE__ */ D(s, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				className: d,
				onClick: () => r(e),
				onMouseEnter: () => i?.(e),
				onMouseLeave: () => a?.(e),
				children: [/* @__PURE__ */ E("span", {
					className: p,
					style: {
						borderColor: u,
						backgroundColor: t.includes(e) ? u : "transparent"
					}
				}), /* @__PURE__ */ E(f.Paragraph, {
					variant: "4",
					subdued: !0,
					children: e
				})]
			}, e);
		})
	});
}), $s = ({ instrument: e, visualization: t }) => {
	let { data: { series: n, options: r } } = e, i = r?.legend?.layout === "horizontal", [a, o] = j(n.filter(({ options: e }) => e?.visible ?? !0).map(({ label: e }) => e)), [s, c] = w(null);
	P(() => {
		l();
	}, [n.length]);
	let l = y(() => {
		o.set(n.map(({ label: e }) => e));
	}, [n, o]), u = y((e) => {
		a.includes(e) && c(e);
	}, [a]), d = S(() => Xs(u, 300), [u]), f = y(() => {
		d.cancel(), c(null);
	}, [d]), p = y((e) => {
		a.length === n.length ? o.filter((t) => t === e) : a.length === 1 && a.includes(e) ? l() : a.includes(e) ? o.removeAt(a.indexOf(e)) : o.push(e);
	}, [
		n.length,
		l,
		a,
		o
	]), m = S(() => n.length < 10 ? {
		onMouseEnterLegendItem: d,
		onMouseLeaveLegendItem: f,
		hoveredLegend: s
	} : {}, [
		d,
		f,
		s,
		n.length
	]);
	return {
		legend: a,
		legendProps: S(() => ({
			layout: r?.legend?.layout,
			align: i ? "center" : "right",
			verticalAlign: i ? "bottom" : "middle",
			wrapperStyle: {
				overflow: "auto",
				...i ? { bottom: 0 } : {
					right: 0,
					width: 208,
					maxHeight: "100%"
				}
			},
			content: () => /* @__PURE__ */ E(Qs, {
				visualization: t,
				instrument: e,
				legend: a,
				onToggleLegendItem: p,
				...m
			})
		}), [
			p,
			e,
			i,
			a,
			m,
			r?.legend?.layout,
			t
		]),
		hoveredLegend: s
	};
}, ec = we, tc = Te, nc = Ee, rc = (e) => {
	let { outerRadius: t } = e;
	return /* @__PURE__ */ D("g", { children: [/* @__PURE__ */ E(me, { ...e }), /* @__PURE__ */ E(me, {
		...e,
		innerRadius: t,
		outerRadius: t + 10,
		fillOpacity: .4
	})] });
}, ic = (e) => {
	let { name: t, value: n, cx: r, cy: i, midAngle: a, outerRadius: o, fill: s, percent: c } = e;
	if (!n || !(typeof c == "number" && c >= .01) || typeof r != "number" || typeof i != "number" || typeof a != "number" || typeof o != "number") return null;
	let l = Math.PI / 180, u = o + 24, d = r + o * Math.cos(-a * l), f = i + o * Math.sin(-a * l), p = r + u * Math.cos(-a * l), m = i + u * Math.sin(-a * l), h = p + (p > r ? 12 : -12), g = m;
	return /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E("polyline", {
		points: `${d},${f} ${p},${m} ${h},${g}`,
		stroke: s,
		fill: "none",
		strokeWidth: 1
	}), /* @__PURE__ */ E("text", {
		...$.tickProps,
		fill: be.color.secondary,
		x: h + (h > r ? 8 : -8),
		y: g,
		textAnchor: h > r ? "start" : "end",
		dominantBaseline: "middle",
		children: t
	})] });
}, ac = ({ instrument: e, legend: t, hoveredLegend: n, hoveredCategory: r }) => {
	let { data: i, layout: a } = e, o = y(() => {
		let { categories: e, series: o } = i, s = o.filter(({ label: e }) => t.includes(e)), c = a === "vertical", l = c ? [
			0,
			2,
			2,
			0
		] : [
			2,
			2,
			0,
			0
		];
		return o.map(({ label: a, options: u, data: d }, f) => {
			let p = Os(f, i.options?.theme, u?.color), m = u?.stack, h = m ? s.filter((e) => e.options?.stack === m) : [], g = !m || ec(h)?.label === a, _ = Vs(i.formats), v = s.length <= 10 && (!m || g), y = /* @__PURE__ */ D(T, { children: [v && /* @__PURE__ */ E(oe, {
				position: c ? "right" : "top",
				valueAccessor: ({ payload: e }) => m ? nc(Object.values(tc(e, h.map((e) => e.label)))) : Number(e[a] ?? 0),
				formatter: (e) => e ? Ss(e, _) : "",
				...$.tickProps,
				offset: 8,
				fontSize: "var(--dixa-typography-size-100)",
				width: 0
			}), d.map((t, s) => {
				let c = o.length > 1 ? p : Os(s, i.options?.theme, e[s]?.options?.color ?? u?.color);
				return /* @__PURE__ */ E(ie, {
					fill: c,
					fillOpacity: (r === null || r === s) && (n === null || n === a) ? 1 : .4
				}, `${a}-${s}`);
			})] });
			return {
				key: a,
				dataKey: a,
				stackId: m,
				fill: p,
				radius: g ? l : 0,
				maxBarSize: 80,
				hide: !t.includes(a),
				children: y
			};
		});
	}, [
		i,
		r,
		n,
		a,
		t
	]), s = y(() => {
		let { series: e } = i;
		return e.map(({ label: e, options: r }, a) => ({
			key: e,
			type: "monotone",
			dot: !1,
			activeDot: { r: 5 },
			dataKey: e,
			stroke: Os(a, i.options?.theme, r?.color),
			strokeWidth: 2,
			strokeOpacity: n === null || n === e ? 1 : .4,
			connectNulls: !0,
			hide: !t.includes(e)
		}));
	}, [
		i,
		n,
		t
	]), c = y(() => {
		let { series: e } = i;
		return e.map(({ label: e, options: r }, a) => {
			let o = Os(a, i.options?.theme, r?.color), s = n === null || n === e;
			return {
				key: e,
				type: "monotone",
				dot: !1,
				activeDot: { r: 5 },
				dataKey: e,
				stackId: r?.stack,
				stroke: o,
				strokeWidth: 2,
				fill: o,
				fillOpacity: s ? .9 : .2,
				strokeOpacity: +!!s,
				connectNulls: !0,
				hide: !t.includes(e)
			};
		});
	}, [
		i,
		n,
		t
	]), l = y((e) => {
		let { categories: t, series: n } = i, r = t.map(({ label: e, options: t }, n) => {
			let r = Os(n, i.options?.theme, t?.color);
			return /* @__PURE__ */ E(ie, {
				fill: r,
				style: { outline: "none" }
			}, e);
		});
		return {
			dataKey: n[0]?.label,
			cx: "50%",
			cy: "50%",
			label: ic,
			labelLine: !1,
			activeShape: rc,
			inactiveShape: { fillOpacity: .4 },
			stroke: ye.neutral["000"],
			strokeWidth: 1.5,
			innerRadius: e === "donut" ? "50%" : 0,
			outerRadius: "80%",
			startAngle: 90,
			endAngle: -270,
			children: r
		};
	}, [i]);
	return { getSeriesProps: y((e) => {
		switch (e) {
			case "bar": return o();
			case "line": return s();
			case "area": return c();
			case "pie":
			case "donut": return l(e);
			default: return [];
		}
		return [];
	}, [
		c,
		o,
		s,
		l
	]) };
}, oc = v(function({ instrument: e, panel: t, timezone: n, syncOptions: r, onChangeGranularity: i, onChangeVisualization: a, onChangeFormat: c }) {
	let [l, u] = w(t.controls?.settings.visualization ?? e.visualization), [d, p] = w(null), { data: m, layout: g, title: _ } = e, v = g === "horizontal", b = g === "vertical", x = S(() => zs(m, { omitZero: l === "bar" }), [m, l]), C = S(() => m.granularities?.find(({ selected: e }) => e)?.value, [m.granularities]), O = S(() => {
		if (!m.options?.visualizations) return [];
		let e = ["bar"], t = m.series.length === 1;
		return m.categories.every(({ label: e }) => us(e)) ? e.push("line", "area") : t && e.push("pie", "donut"), e;
	}, [
		m.categories,
		m.options?.visualizations,
		m.series.length
	]), { xAxisProps: k, yAxisProps: A } = Ys({
		instrument: e,
		granularity: C,
		timezone: n,
		syncOptions: r
	}), { legend: j, legendProps: M, hoveredLegend: N } = $s({
		instrument: e,
		visualization: l
	}), { getSeriesProps: ie } = ac({
		instrument: e,
		legend: j,
		hoveredLegend: N,
		hoveredCategory: d
	});
	P(() => {
		u(t.controls?.settings.visualization ?? e.visualization);
	}, [t.controls?.settings.visualization, e.visualization]);
	let oe = y((e) => {
		u(e), a?.(e);
	}, [a]), me = (e) => {
		if (!e?.isTooltipActive) {
			p(null);
			return;
		}
		let t = e.activeTooltipIndex;
		if (typeof t != "number") return;
		let n = Object.values(x[t] ?? {}).length > 1;
		p(n ? t : null);
	}, ve = () => {
		p(null);
	}, ye = () => l === "line" ? ie(l).map(({ key: e, ...t }) => /* @__PURE__ */ E(ce, { ...t }, e)) : l === "bar" ? ie(l).map(({ key: e, ...t }) => /* @__PURE__ */ E(te, { ...t }, e)) : l === "area" ? ie(l).map(({ key: e, ...t }) => /* @__PURE__ */ E(ee, { ...t }, e)) : l === "pie" || l === "donut" ? /* @__PURE__ */ E(ue, {
		data: x,
		...ie(l)
	}) : null, be = () => {
		let i = m.options?.legend?.layout, a = {
			layout: g,
			syncId: r?.tooltip ? t.id : void 0,
			data: x,
			margin: {
				top: v ? 16 : 0,
				right: b || i === "vertical" ? 16 : 0,
				bottom: i === "horizontal" ? 8 : 0,
				left: 0
			}
		}, o = l === "bar" || l === "line" || l === "area", s = /* @__PURE__ */ D(T, { children: [
			o && /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E(ge, { ...k }), /* @__PURE__ */ E(_e, { ...A })] }),
			o && m.options?.cartesian && /* @__PURE__ */ E(re, {
				vertical: b,
				horizontal: v,
				stroke: "var(--dixa-color-neutral-200)"
			}),
			o && m.references?.map(({ value: e, label: t }, n) => /* @__PURE__ */ E(fe, {
				...v ? { y: e } : { x: e },
				stroke: "var(--dixa-color-neutral-500)",
				strokeDasharray: "5 5",
				isFront: !0,
				children: /* @__PURE__ */ E(ae, {
					value: t,
					offset: 8,
					fontSize: "var(--dixa-typography-size-200)",
					position: v ? "insideBottomLeft" : "insideTopLeft"
				})
			}, n)),
			m.options?.legend && /* @__PURE__ */ E(se, { ...M }),
			m.options?.tooltip && /* @__PURE__ */ E(he, {
				content: (t) => /* @__PURE__ */ E(Ks, {
					instrument: e,
					granularity: C,
					timezone: n,
					tooltipProps: t
				}),
				cursor: { fill: "transparent" }
			}),
			ye()
		] });
		switch (l) {
			case "bar": return /* @__PURE__ */ E(ne, {
				...a,
				barGap: "1",
				onMouseMove: me,
				onMouseLeave: ve,
				children: s
			});
			case "line": return /* @__PURE__ */ E(le, {
				...a,
				children: s
			});
			case "area": return /* @__PURE__ */ E(F, {
				...a,
				children: s
			});
			case "pie":
			case "donut": return /* @__PURE__ */ E(de, {
				...a,
				children: s
			});
		}
	};
	if (!m.categories.length || !m.series.length) return /* @__PURE__ */ E(s, {
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		children: /* @__PURE__ */ E(o, {
			title: "No data available",
			description: "There is no data available for the selected period and filters.",
			icon: $.visualizationIcons[l]
		})
	});
	let xe = [
		m.formats && m.formats.length > 1 ? /* @__PURE__ */ E(As, {
			formats: m.formats,
			onChangeFormat: c
		}, "format") : null,
		m.granularities && m.granularities.length > 1 ? /* @__PURE__ */ E(js, {
			granularities: m.granularities,
			onChangeGranularity: i
		}, "granularity") : null,
		m.options?.visualizations ? /* @__PURE__ */ E(Js, {
			visualization: l,
			visualizations: O,
			onChangeVisualization: oe
		}, "visualization") : null
	], Se = xe.some(Boolean);
	return /* @__PURE__ */ D(T, { children: [
		_ && /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(f.Heading, {
			variant: "heading-4",
			children: _
		}) }),
		Se && /* @__PURE__ */ E(s, {
			alignSelf: "flex-end",
			gap: "300",
			children: xe.map((e, t) => /* @__PURE__ */ E(h, { children: e }, t))
		}),
		/* @__PURE__ */ E(pe, {
			className: ks.container,
			width: "100%",
			height: "100%",
			debounce: 100,
			children: be()
		})
	] });
}), sc = De, cc = Oe, lc = { trigger: "_trigger_1mrk9_1" }, uc = v(function({ title: e, metrics: t, children: n }) {
	let r = /* @__PURE__ */ D(s, {
		flexDirection: "column",
		gap: "200",
		children: [/* @__PURE__ */ E(f.Paragraph, {
			variant: "1",
			color: "inherit",
			children: e
		}), t.length > 0 && /* @__PURE__ */ E(Ns, {
			bounded: !0,
			children: t.map((e, t) => /* @__PURE__ */ E(Rs, {
				instrument: e,
				theme: "dark"
			}, t))
		})]
	});
	return /* @__PURE__ */ E(p, {
		content: r,
		wrap: "div",
		wrapProps: { className: lc.trigger },
		children: n
	});
}), dc = {
	cell: "_cell_hfkay_1",
	cellText: "_cellText_hfkay_11",
	cellDimmed: "_cellDimmed_hfkay_14",
	cellContent: "_cellContent_hfkay_18"
}, fc = v(function({ cell: e, dimmed: t = !1, background: n = "transparent", tooltipProps: r, textProps: i = {}, onMouseEnter: a }) {
	let [o, s] = w(!1), c = N(e?.value);
	P(() => {
		if (e?.value !== c) {
			s(!0);
			let e = setTimeout(() => {
				s(!1);
			}, 200);
			return () => {
				clearTimeout(e);
			};
		}
	}, [e?.value]);
	let l = S(() => {
		if (!e) return null;
		let { value: t, format: n } = e;
		return typeof t == "string" ? t : typeof t == "number" && n ? Ss(t, n) : "—";
	}, [e]);
	if (!e) return /* @__PURE__ */ E("div", {
		className: dc.cell,
		onMouseEnter: a,
		"data-testid": "heatmap-instrument-cell"
	});
	let u = /* @__PURE__ */ E("div", {
		className: dc.cellContent,
		children: /* @__PURE__ */ E(f.Paragraph, {
			className: k({ [dc.cellText]: typeof e.value == "string" }),
			variant: "3",
			subdued: !cc(e.value),
			...i,
			children: l
		})
	});
	return /* @__PURE__ */ E("div", {
		className: k(dc.cell, { [dc.cellDimmed]: t || o }),
		onMouseEnter: a,
		style: { backgroundColor: n },
		"data-animating": o,
		"data-testid": "heatmap-instrument-cell",
		children: r?.enabled ? /* @__PURE__ */ E(uc, {
			...r,
			children: u
		}) : u
	});
}), pc = {
	grid: "_grid_1qk2p_1",
	row: "_row_1qk2p_7"
}, mc = Number.isNaN || function(e) {
	return typeof e == "number" && e !== e;
};
function hc(e, t) {
	return !!(e === t || mc(e) && mc(t));
}
function gc(e, t) {
	if (e.length !== t.length) return !1;
	for (var n = 0; n < e.length; n++) if (!hc(e[n], t[n])) return !1;
	return !0;
}
function _c(e, t) {
	t === void 0 && (t = gc);
	var n = null;
	function r() {
		var r = [...arguments];
		if (n && n.lastThis === this && t(r, n.lastArgs)) return n.lastResult;
		var i = e.apply(this, r);
		return n = {
			lastResult: i,
			lastArgs: r,
			lastThis: this
		}, i;
	}
	return r.clear = function() {
		n = null;
	}, r;
}
// src/components/instruments/heatmapInstrument/utils/heatmapTheming.ts
var vc = [
	"100",
	"200",
	"400",
	"500",
	"700"
].map((e) => `var(--dixa-color-purple-${e})`), yc = _c((e) => {
	if (e === null) return {
		backgroundColor: "var(--dixa-color-neutral-000)",
		color: "tertiary"
	};
	let t = Math.min(4, Math.floor(5 / 100 * Math.min(e, 100)));
	return {
		backgroundColor: vc?.[t] ?? "var(--dixa-color-neutral-000)",
		color: t >= 3 ? "white" : "primary"
	};
});
function bc(e) {
	return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
var xc = (e) => {
	let t = e.flatMap(({ data: e }) => e.map((e) => Bs(e).value)).filter(bc);
	return {
		min: Math.min(...t),
		max: Math.max(...t)
	};
}, Sc = (e, { min: t, max: n }) => t === n ? 100 : Math.round(100 * (e - t) / (n - t)), Cc = ({ instrument: e }) => {
	let { data: { categories: t, series: n } } = e, r = C(null), [i, a] = M({
		cell: null,
		column: null,
		row: null
	}), o = S(() => Object.values(i).some((e) => e !== null), [i]), s = S(() => xc(n), [n]);
	x(() => {
		let e = (e) => {
			r.current && !r.current.contains(e.target) && o && a.reset();
		};
		return window.addEventListener("mousemove", e, !0), () => {
			window.removeEventListener("mousemove", e, !0);
		};
	}, [o, a]);
	let c = y((e) => {
		if (!o) return !1;
		let [t, n] = e;
		return i.cell ? !sc(i.cell.id, e) : i.column === null ? i.row !== null && i.row !== t : i.column !== n;
	}, [
		o,
		i.cell,
		i.column,
		i.row
	]), l = y((e) => a.setAll({
		cell: null,
		column: e,
		row: null
	}), [a]), u = y((e) => a.setAll({
		cell: null,
		column: null,
		row: e
	}), [a]), d = y((e) => {
		(o || e !== null) && a.setAll({
			cell: e,
			column: null,
			row: null
		});
	}, [o, a]), f = y(() => {
		o && a.reset();
	}, [o, a]);
	return /* @__PURE__ */ D("div", {
		ref: r,
		className: pc.grid,
		onMouseLeave: () => a.reset(),
		"data-testid": "heatmap-instrument",
		children: [/* @__PURE__ */ D("div", {
			className: pc.row,
			children: [/* @__PURE__ */ E(fc, { onMouseEnter: f }), n.map((e, t) => {
				let r = n[t].metrics ?? [];
				return /* @__PURE__ */ E(fc, {
					cell: {
						id: [0, t],
						value: e.label
					},
					tooltipProps: {
						enabled: r.length > 0,
						title: e.label,
						metrics: r
					},
					onMouseEnter: () => l(t)
				}, e.label);
			})]
		}), t.map((r, i) => {
			let a = t[i].metrics ?? [];
			return /* @__PURE__ */ D("div", {
				className: pc.row,
				children: [/* @__PURE__ */ E(fc, {
					cell: {
						id: [i, 0],
						value: r.label
					},
					tooltipProps: {
						enabled: a.length > 0,
						title: r.label,
						metrics: a
					},
					onMouseEnter: () => u(i)
				}), n.map((t, n) => {
					let a = [i, n], { value: o, metrics: l } = Bs(t.data[i]), u = Vs(e.data.formats), f = cc(o), { backgroundColor: p, color: m } = yc(f ? Sc(o, s) : null);
					return /* @__PURE__ */ E(fc, {
						cell: {
							id: a,
							value: o,
							format: u
						},
						dimmed: c(a),
						background: p,
						tooltipProps: {
							enabled: f,
							title: `${r.label}, ${t.label}`,
							metrics: l?.length ? l : [{
								type: "metric",
								title: "Total",
								data: o,
								format: u === "count" ? "number" : u
							}]
						},
						textProps: { color: m },
						onMouseEnter: () => d(f ? {
							id: a,
							value: o
						} : null)
					}, a.join(","));
				})]
			}, r.label);
		})]
	});
}, wc = {
	legend: "_legend_1k9xu_54",
	trigger: "_trigger_1k9xu_58",
	popover: "_popover_1k9xu_64",
	breakdown: "_breakdown_1k9xu_83"
}, Tc = v(function({ instrument: e }) {
	let { data: { availability: n, media_type: r, away: i } } = e, o = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"], c = "No data available", u = {
		labelWidth: Math.max(...r.map((e) => e.label.length)) * 7,
		theme: o
	}, d = () => /* @__PURE__ */ E(cs, {
		...u,
		value: 0,
		label: "n.a.",
		theme: ["var(--dixa-color-neutral-200)", "var(--dixa-color-neutral-200)"],
		showFullBar: !0
	});
	return /* @__PURE__ */ D(s, {
		flexDirection: "column",
		gap: "400",
		children: [/* @__PURE__ */ D(s, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ E(f.Paragraph, {
				variant: "4",
				subdued: !0,
				children: n.length ? "Availability" : c
			}), n.length ? /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ D(s, {
				gap: "300",
				className: wc.legend,
				children: [n.map((e, n) => /* @__PURE__ */ D(s, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ E(t, {
						width: "6px",
						height: "6px",
						background: o[n],
						borderRadius: "50%"
					}), /* @__PURE__ */ E(f.Paragraph, {
						variant: "4",
						children: e.label
					})]
				}, n)), (() => {
					if (!i || !i.length) return null;
					let [e, t, ...n] = i;
					return /* @__PURE__ */ D(Yo, { children: [/* @__PURE__ */ E(Xo, {
						asChild: !0,
						children: /* @__PURE__ */ E(l, {
							variant: "tertiary",
							icon: "dots-h",
							className: wc.trigger
						})
					}), /* @__PURE__ */ E(Zo, { children: /* @__PURE__ */ E(Qo, {
						side: "right",
						className: wc.popover,
						children: /* @__PURE__ */ D("ul", {
							className: wc.breakdown,
							children: [
								/* @__PURE__ */ D("li", { children: [/* @__PURE__ */ E(f.Paragraph, {
									variant: "1",
									children: e.label
								}), /* @__PURE__ */ E(f.Paragraph, {
									variant: "1",
									children: ls(e.value)
								})] }),
								/* @__PURE__ */ D("li", { children: [/* @__PURE__ */ E(f.Paragraph, {
									variant: "2",
									subdued: !0,
									children: t.label
								}), /* @__PURE__ */ E(f.Paragraph, {
									variant: "2",
									subdued: !0,
									children: ls(t.value)
								})] }),
								/* @__PURE__ */ E(a, {}),
								n.map((e, t) => /* @__PURE__ */ D("li", { children: [/* @__PURE__ */ E(f.Paragraph, {
									variant: "2",
									children: e.label
								}), /* @__PURE__ */ E(f.Paragraph, {
									variant: "1",
									children: ls(e.value)
								})] }, t))
							]
						})
					}) })] });
				})()]
			}), /* @__PURE__ */ E(cs, {
				...u,
				value: n[0].value,
				label: "Total",
				showFullBar: !0,
				showDifference: !0
			})] }) : d()]
		}), /* @__PURE__ */ D(s, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ E(f.Paragraph, {
				variant: "4",
				subdued: !0,
				children: r.length ? "Availability per channel" : c
			}), r.length > 0 ? /* @__PURE__ */ E(s, {
				flexDirection: "column",
				gap: "200",
				children: r.map((e, t) => /* @__PURE__ */ _(cs, {
					...u,
					key: t,
					value: e.value,
					label: e.label
				}))
			}) : d()]
		})]
	});
}), Ec = {
	tooltip: "_tooltip_h4i5v_1",
	trigger: "_trigger_h4i5v_5"
}, Dc = ({ text: e }) => /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E("span", { children: e }), /* @__PURE__ */ E(p, {
	className: Ec.tooltip,
	content: e,
	wrap: "div",
	wrapProps: { className: Ec.trigger }
})] }), Oc = v(function({ value: e }) {
	let [t, ...n] = e;
	return /* @__PURE__ */ D(s, {
		gap: "200",
		alignItems: "center",
		children: [/* @__PURE__ */ E(f.Paragraph, {
			variant: "2",
			as: "span",
			children: t
		}), n.length > 0 && /* @__PURE__ */ E(p, {
			content: n.join(", "),
			children: /* @__PURE__ */ D(f.ExternalLink, {
				as: "span",
				children: [
					"+ ",
					n.length,
					" more"
				]
			})
		})]
	});
}), kc = ({ cell: t, format: n, timezone: r, customFormats: i }) => {
	let a = S(() => {
		if (!t || Ac(t.value)) return /* @__PURE__ */ E(f.Paragraph, {
			variant: "2",
			color: "neutral.500",
			children: "n.a."
		});
		let { value: e, label: a } = t;
		if (a) return a;
		if (i?.[n]) return i[n]?.({ value: e });
		switch (n) {
			case "boolean": return e ? "Y" : "N";
			case "date": return ve.tz(e, r).format("L, LT");
			case "count": return ps(e);
			case "number": return ms(e);
			case "percentage": return `${ms(e)}%`;
			case "duration": return ls(e);
			case "csid": return `#${e}`;
			case "rating": return `${e}`;
			case "presence": return /* @__PURE__ */ E(cs, {
				value: e,
				showFullBar: !0
			});
			case "tags": return /* @__PURE__ */ E(ke, {
				tags: e,
				limit: 1
			});
			case "text": return /* @__PURE__ */ E(Dc, { text: e });
			case "list": return /* @__PURE__ */ E(Oc, { value: e });
			default: return `${e}`;
		}
	}, [
		t,
		i,
		n,
		r
	]);
	return t?.ui?.type === "badge" ? /* @__PURE__ */ E(e, {
		variant: t.ui.variant,
		size: "medium",
		children: /* @__PURE__ */ E(T, { children: a })
	}) : /* @__PURE__ */ E(T, { children: a });
};
function Ac(e) {
	let t = e === null, n = typeof e == "string" && e.trim() === "", r = Array.isArray(e) && !e.length;
	return t || n || r;
}
var jc = {
	tableWrapper: "_tableWrapper_1xmkm_1",
	tableWrapperEmpty: "_tableWrapperEmpty_1xmkm_4",
	thCell: "_thCell_1xmkm_8",
	tdCell: "_tdCell_1xmkm_12",
	tooltip: "_tooltip_1xmkm_20"
}, Mc = Ae, Nc = je, Pc = (e) => typeof e == "string" || typeof e == "number" || typeof e == "boolean", Fc = (e, t) => {
	let n = e.cells.find((e) => e.column === t.key);
	return !n || n.value === null ? null : (n.value, n.value);
}, Ic = ({ data: { columns: e, rows: t }, limit: n = 50, sortStatus: r }) => {
	let i = Math.ceil(t.length / n), [a, o] = w(1);
	P(() => {
		a !== 1 && o(1);
	}, [r, i]);
	let s = S(() => {
		if (!r) return t;
		let n = e.find(({ key: e }) => e === r.sortBy);
		return n ? Nc(t, [(e) => !Mc(Fc(e, n)), (e) => Fc(e, n)], ["desc", r.direction]) : t;
	}, [
		e,
		t,
		r
	]);
	return {
		rows: S(() => s.slice((a - 1) * n, a * n), [
			a,
			n,
			s
		]),
		currentPage: a,
		totalPages: i,
		setPage: o
	};
}, Lc = ({ instrument: e, timezone: t, onReadInstruments: r, onLoadAll: i, onSortChange: a, customFormats: l }) => {
	let { title: p, data: m, data: { columns: h, options: g } } = e, [_, v] = w(null), b = C(null), x = g?.limit ?? 50, { rows: S, currentPage: O, totalPages: A, setPage: j } = Ic({
		data: m,
		limit: x,
		sortStatus: _
	}), M = m.rows.length === 0, N = !!g?.next_page, ee = !N && A > 1;
	P(() => {
		b.current && (b.current.scrollTop = 0);
	}, [O]);
	let F = y(() => (i?.(), r({ meta: { pagination: { limit: null } } })), [i, r]), te = y(async (e) => {
		N && await F(), v(e), a?.(e);
	}, [
		F,
		a,
		N
	]);
	return /* @__PURE__ */ D(T, { children: [p && /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(f.Heading, {
		variant: "heading-4",
		children: p
	}) }), /* @__PURE__ */ D(d, {
		stickyHeader: !0,
		sortingProps: {
			sortStatus: _,
			onSortChange: te
		},
		wrapperProps: { className: k(jc.tableWrapper, { [jc.tableWrapperEmpty]: M }) },
		wrapperRef: b,
		hoverable: !M,
		children: [
			/* @__PURE__ */ E(d.Thead, { children: /* @__PURE__ */ E(d.Tr, { children: h.map(({ key: e, label: t, sortable: n }) => /* @__PURE__ */ E(d.Th, {
				className: jc.thCell,
				columnId: n ? e : null,
				children: t
			}, e)) }) }),
			/* @__PURE__ */ D(d.Tbody, { children: [M && /* @__PURE__ */ E(d.Tr, { children: /* @__PURE__ */ E(d.Td, {
				colSpan: h.length,
				children: /* @__PURE__ */ E(o, {
					title: "No data available",
					description: "There is no data available for the selected period and filters.",
					icon: "th"
				})
			}) }), S.map((e, n) => {
				let r = `row-${n}`;
				return /* @__PURE__ */ E(d.Tr, { children: h.map(({ key: n, format: i }, a) => {
					let o = e.cells.find((e) => e.column === n);
					return /* @__PURE__ */ E(d.Td, {
						className: jc.tdCell,
						children: /* @__PURE__ */ E(kc, {
							cell: o,
							format: i,
							timezone: t,
							customFormats: l
						})
					}, `${r}-cell-${a}`);
				}) }, r);
			})] }),
			N && /* @__PURE__ */ E(d.Footer, { children: /* @__PURE__ */ D(s, {
				alignItems: "center",
				justifyContent: "center",
				gap: "300",
				children: [/* @__PURE__ */ D(s, {
					gap: "100",
					alignItems: "center",
					children: [/* @__PURE__ */ E(c, {
						tooltipClassName: jc.tooltip,
						text: `By default we only load the first ${x} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
					}), /* @__PURE__ */ D(f.Paragraph, {
						variant: "2",
						children: ["Showing only the ", /* @__PURE__ */ D("b", { children: [
							"first ",
							x,
							" results"
						] })]
					})]
				}), /* @__PURE__ */ E(n, {
					variant: "secondary",
					onClick: F,
					children: "Load all results"
				})]
			}) }),
			ee && /* @__PURE__ */ E(d.Footer, { children: /* @__PURE__ */ E(s, {
				alignItems: "center",
				justifyContent: "center",
				children: /* @__PURE__ */ E(u, {
					pageCount: A,
					currentPage: O,
					pageRangeDisplayed: 6,
					onPageChange: j
				})
			}) })
		]
	})] });
};
export { es as AnalyticsMenu, oc as ChartInstrument, Cc as HeatmapInstrument, Rs as MetricInstrument, Is as MetricInstrumentData, Ns as MetricInstrumentsGrid, cs as PercentageBar, Tc as PresenceInstrument, Lc as TableInstrument, hs as categorizeInstruments, $ as chartAppearance, ps as formatAbbreviateNumber, Ss as formatInstrumentNumber, ms as formatLocalizedNumber, ls as formatMillisecondsToDuration, Vs as getChartSeriesFormat, Bs as getChartSeriesValue, xs as isAIInsightInstrument, _s as isChartInstrument, us as isDateLikeString, vs as isHeatmapInstrument, gs as isMetricInstrument, bs as isPresenceInstrument, ys as isTableInstrument, Pc as isTableInstrumentDataValuePrimitive, Os as resolveChartElementColor, Ds as resolveInstrumentColor };

//# sourceMappingURL=index.js.map